/* eslint-disable eslint-comments/no-unlimited-disable -- disable all rules */
/* eslint-disable -- disable all rules */
/* prettier-ignore */
// This is a KA-custom version of https://cdn.crowdin.net/jipt/jipt.js, based
// on an unminified version of the script shared with us by Crowdin.
//
// A copy of the unmiminified version without our patches is located in
// jipt-base.js.
//
// TODO(tom) Instructions for how to update.
(function(undefined) {
  var $, // self loaded jQuery object

    editContextTimeout = null,

    stringsToUpdate = {
      updatedStrings: [],
      newStrings: []
    },

    isMobile = navigator.userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|Windows Phone/i),

    config = {
      start_type: 'default',
      preload_texts: 'auto',
      project: document.domain,

      // before_dom_insert(text, node, attribute)
      before_dom_insert: function(text) { return text; },

      // before_commit(source, translation, context, language)
      before_commit: null,

      // edit_string_context(context)
      edit_strings_context: null,

      // show badges for all elements
      touch_optimized: 'ontouchstart' in document.documentElement,

      // only tag visible phrases in screenshots
      tag_only_visible_phrases: false,

      // escape()
      escape: null,

      // sub-domain for enterprise
      domain: null
    },

    setCookie = function(name, value, expires) {
      if (typeof expires === 'undefined') {
        var expires_date = new Date((new Date()).getTime() + (365 * 24 * 60 * 60 * 1000));
        expires = expires_date.toGMTString();
      }

      document.cookie = name + "=" + escape(value) + "; path=/; expires=" + expires;
    },

    removeCookie = function(name) {
      document.cookie = name + "=; path=/; expires = Thu, 01 Jan 1970 00:00:00 GMT";
    },

    getCookie = function(check_name) {
      var documentCookies = document.cookie.split(';');
      var temporaryCookies = '';
      var cookieName = '';
      var cookieValue = '';
      var isThereAnyCookie = false;

      for(var i = 0; i < documentCookies.length; i++) {
        temporaryCookies = documentCookies[i].split('=');
        cookieName = temporaryCookies[0].replace(/^\s+|\s+$/g, '');

        if(cookieName === check_name) {
          isThereAnyCookie = true;

          if(temporaryCookies.length > 1) {
            cookieValue = unescape(temporaryCookies[1].replace(/^\s+|\s+$/g, ''));
          }

          return cookieValue;
        }

        temporaryCookies = null;
        cookieName = '';
      }

      if(!isThereAnyCookie) {
        return null;
      }
    },

    Storage = {
      save: function (key,value){
        var full_key = 'jipt_' + key + '_' + get_project_identifier();

        if(window.localStorage){
          localStorage.setItem(full_key, value);
        } else {
          setCookie(full_key, value);
        }
      },
      get: function(key) {
        var value = null;
        var full_key = 'jipt_' + key + '_' + get_project_identifier();

        if(window.localStorage) {
          value = localStorage.getItem(full_key) ? localStorage.getItem(full_key) : null;

          // from (string) to (type) 'undefined'
          value = value === 'undefined' ? undefined : value;
        } else {
          value = getCookie(full_key);
        }

        return value;
      },
      delete: function(key) {
        var full_key = 'jipt_' + key + '_' + get_project_identifier();

        if(window.localStorage) {
          localStorage.removeItem(full_key);
        } else {
          removeCookie(full_key);
        }
      },
    },

    Url = {
      join: "join",
      login: "login",
      enterpriseLogin: "u/signin",

      entryPoint: '',
      apiEntryPoint: '',
      jiptCDN: 'https://cdn.crowdin.com/jipt',

      authDomain: 'https://accounts.crowdin.com',
      crowdinDomain: 'crowdin.com',

      getEntryPoint: function() {
        if(this.entryPoint.length === 0) {
          var domain = config.domain != null ? config.domain  + '.' : '';

          this.entryPoint = 'https://' + domain + this.crowdinDomain;
        }

        return this.entryPoint;
      },

      getAuthEntryPoint: function(url, params) {
        params = params || {};
        if (config.domain !== null) {
          params.domain = config.domain;
        }

        var queryParams = $.param(params);

        return this.authDomain + url + (queryParams ? '?' + queryParams : '');
      },

      getFullUrl: function(path) {
        return this.getEntryPoint() + path;
      },

      getJiptPath: function(action) {
        var pathAction;

        if(action == this.join || action == this.login) {
          pathAction = (config.domain) ? this.enterpriseLogin : action;
        } else {
          pathAction = this.login;
        }

        return this.getAuthEntryPoint('/login', {
          continue: '/' + pathAction + '?redirect_hash=' + jipt.user.redirectHash
        });
      },
    },

    get_project_identifier = function() {
      return config.project;
    },

    applyUserConfig = function() {
      var cfg = _jipt || [];

      for(var i = 0; i < cfg.length; i++) {
        config[cfg[i][0]] = cfg[i][1];
      }
    },

    maskElement = function(element) {
      var mask, message, loader, parent, elementLoadInterval, maskStyle  = '';

      element.attr('style', 'opacity: 0;');

      maskStyle += 'position: fixed;';
      maskStyle += 'top: 0;';
      maskStyle += 'right: 0;';
      maskStyle += 'bottom: 0;';
      maskStyle += 'left: 0;';
      maskStyle += 'z-index: 2047483647;';
      maskStyle += 'text-align: center;';
      maskStyle += 'background-color: #fff;';

      mask = document.createElement('div');
      mask.setAttribute('id', 'crowdin-jipt-mask');
      mask.setAttribute('style', maskStyle);

      message = document.createElement('div');
      message.classList.add('jipt-loader-wrapper');

      loader = document.createElement('div');
      loader.classList.add('jipt-loader');
      loader.innerHTML = '<svg class="jipt-loader-logo" id="ea69YclA0j21" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="-12 -12 96 96" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" width="96" height="96" style="background-color:transparent">' +
        '<style>' +
        '<![CDATA[#ea69YclA0j22_tr { animation: ea69YclA0j22_tr__tr 3000ms linear infinite normal forwards;}' +
        '@keyframes ea69YclA0j22_tr__tr {' +
        '0% {transform: translate(36px, 36px) rotate(0deg);}' +
        '16.666667% {transform: translate(36px, 36px) rotate(0deg);}' +
        '33.333333% {transform: translate(36px, 36px) rotate(90deg);animation-timing-function: cubic-bezier(0, 0, 0.58, 1);}' +
        '50% {transform: translate(36px, 36px) rotate(90deg);animation-timing-function: cubic-bezier(0, 0, 0.58, 1);}' +
        '66.666667% {transform: translate(36px, 36px) rotate(180deg);}' +
        '100% {transform: translate(36px, 36px) rotate(180deg);}' +
        '}' +
        '#ea69YclA0j23_tr {animation: ea69YclA0j23_tr__tr 3000ms linear infinite normal forwards;}' +
        '@keyframes ea69YclA0j23_tr__tr {' +
        '0% {transform: translate(36px, 36px) rotate(0deg);}' +
        '16.666667% {transform: translate(36px, 36px) rotate(90deg); animation-timing-function: cubic-bezier(0, 0, 0.58, 1);}' +
        '33.333333% {transform: translate(36px, 36px) rotate(90deg); animation-timing-function: cubic-bezier(0, 0, 0.58, 1);}' +
        '50% {transform: translate(36px, 36px) rotate(180deg);}' +
        '100% {transform: translate(36px, 36px) rotate(180deg);}' +
        '}' +
        ']]>' +
        '</style>' +
        '<g id="ea69YclA0j22_tr" transform="translate(36,36) rotate(0)">' +
        '<path d="M49.7297,72h-27.4594C8.02429,72,0,63.8244,0,49.7297v-27.4594C0,8.17563,8.02429,0,22.2703,0h27.4594C64.275,0,72,7.87631,72,22.2703v27.4594C72,64.1237,64.275,72,49.7297,72Z" transform="translate(-36,-36)" fill="#1e88e5"/>' +
        '</g>' +
        '<g id="ea69YclA0j23_tr" transform="translate(36,36) rotate(0)">' +
        '<path d="M49.7297,72h-27.4594C8.02429,72,0,63.8244,0,49.7297v-27.4594C0,8.17563,8.02429,0,22.2703,0h27.4594C64.275,0,72,7.87631,72,22.2703v27.4594C72,64.1237,64.275,72,49.7297,72Z" transform="translate(-36,-36)" fill="#43a047"/>' +
        '</g>' +
        '<path d="M49.7297,72h-27.4594C8.02429,72,0,63.8244,0,49.7297v-27.4594C0,8.17563,8.02429,0,22.2703,0h27.4594C64.275,0,72,7.87631,72,22.2703v27.4594C72,64.1237,64.275,72,49.7297,72Z" fill="#263238"/>' +
        '<path d="M46.2564,49.0537c-1.3472,0-2.5476-.4181-3.5412-1.2371-1.1871-.9641-2.1307-2.4016-2.1641-4.0914-.0166-.8536.8803-.8536.8803-.8536s1.4572-.0172,2.1641-.0172c.7069.0172.9136,1.0366.947,1.2924.2734,2.291,1.5238,3.2897,2.4841,3.7458.5769.273.4335,1.1266-.7702,1.1646v-.0035Z" fill="#fff"/>' +
        '<path d="M34.1594,37.4118c-1.1871-.1451-2.9477-.2695-4.0847-.5598-1.844-.4699-1.7939-2.1874-1.7139-2.7472.2234-1.6794.8169-3.2344,1.7306-4.6789c1.137-1.7692,2.7709-3.3242,4.8716-4.589c3.9413-2.3671,9.4531-3.6871,15.5085-3.6871c4.4381,0,9.0696.5978,9.1163.5978.4168.0553.7203.47.7036.9399s-.3368.8294-.7536.8674c-.6736-.0173-1.3305-.0173-1.954-.0173-6.1687,0-10.5602.8674-13.8279,2.7472-3.2211,1.8418-5.4651,4.6616-6.9857,8.836-.16.3628-.6902,2.5122-2.6108,2.2945v-.0035Z" fill="#fff"/>' +
        '<path d="M39.5413,54.6382c-3.061.0657-5.9453-1.3684-8.1293-3.8703-1.8506-2.1182-2.9643-4.2538-3.1711-6.9941-.1267-1.79.6369-2.4085,1.6739-2.3014.7169.0725,2.9477.1831,4.2248.4561.9569.2004,1.5938.7499,1.7539,1.8799.8436,6.0265,4.5115,8.3971,6.6955,8.9085.3835.0899.6202.3456.6069.8052-.0167.4388-.2601,1.0401-3.6512,1.1127l-.0034.0034Z" fill="#fff"/>' +
        '<path d="M30.8214,59.9874c-2.1707.0933-4.2947-.3593-4.9016-.4699-2.5542-.47-4.6949-1.282-6.5288-2.4881-4.3915-2.8819-7.0424-7.972-7.3591-13.9986-.0801-1.4306-.2568-4.164,3.0343-3.9567c1.3571.0761,3.5112.7534,5.0283,1.206c1.884.546,2.7943,2.0527,2.7943,3.542c0,8.4974,7.4258,14.1127,10.6669,14.1127.7735,0,.9569.4769.8636.933-.0734.3629-.2701.978-3.5945,1.1231l-.0034-.0035Z" fill="#fff"/>' +
        '<path d="M19.4942,35.0168c-1.2837-.2384-2.5375-.7878-3.7579-1.1023-3.7746-.971-3.131-4.9173-2.7776-5.9989c3.4345-10.4774,14.3381-13.9814,23.1377-14.9178c8.2861-.8812,16.9556-.2005,25.0316,2.1286.5769.159,2.1674.5564,1.824,1.5239s-1.3005.2938-10.1101.0933c-2.9043-.0656-5.8052.1244-8.7162.5875-4.995.7879-10.13,2.4224-14.258,5.871-1.9907,1.6691-3.7413,3.7978-4.9117,6.3134-.3067.66-.5468,1.3201-.7536,1.9801-.21.698-.997,4.202-4.7049,3.5247l-.0033-.0035Z" fill="#fff"/>' +
        '<path d="M40.618,37.0388c.7069-3.2793,3.848-8.4766,13.5712-8.1172c2.2307.0726,1.2104,1.6483.11,1.6138-5.4985-.197-8.106,3.4763-9.4731,7.2015-.4402,1.1991-1.4438,1.3788-2.7009,1.1645-.8803-.1624-1.8373-.2695-1.5072-1.8626Z" fill="#fff"/>' +
        '</svg>';

      elementLoadInterval = window.setInterval(function() {
        parent = element[0];

        if(parent !== undefined) {
          window.clearInterval(elementLoadInterval);
          parent.appendChild(mask);
          mask.appendChild(message);
          message.appendChild(loader);
          element.attr('style', 'opacity: unset;');
        }
      }, 100);
    },

    unmaskElement = function(element) {
      var mask = element.find('#crowdin-jipt-mask');

      if(mask) {
        mask.remove();
      }
    },

    maskDocument = function() {
      var mask, message, loader, body, bodyLoadInterval, maskStyle  = '';

      document.documentElement.style.opacity = '0';

      maskStyle += 'position: fixed;';
      maskStyle += 'top: 0;';
      maskStyle += 'right: 0;';
      maskStyle += 'bottom: 0;';
      maskStyle += 'left: 0;';
      maskStyle += 'z-index: 2037483647;';
      maskStyle += 'text-align: center;';
      maskStyle += 'background-color: #fff;';

      mask = document.createElement('div');
      mask.setAttribute('id', 'crowdin-jipt-mask');
      mask.setAttribute('style', maskStyle);

      message = document.createElement('div');
      message.classList.add('jipt-loader-wrapper');

      loader = document.createElement('div');
      loader.classList.add('jipt-loader');
      loader.innerHTML = '<svg class="jipt-loader-logo" id="ea69YclA0j21" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="-12 -12 96 96" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" width="96" height="96" style="background-color:transparent">' +
        '<style>' +
          '<![CDATA[#ea69YclA0j22_tr { animation: ea69YclA0j22_tr__tr 3000ms linear infinite normal forwards;}' +
            '@keyframes ea69YclA0j22_tr__tr {' +
              '0% {transform: translate(36px, 36px) rotate(0deg);}' +
              '16.666667% {transform: translate(36px, 36px) rotate(0deg);}' +
              '33.333333% {transform: translate(36px, 36px) rotate(90deg);animation-timing-function: cubic-bezier(0, 0, 0.58, 1);}' +
              '50% {transform: translate(36px, 36px) rotate(90deg);animation-timing-function: cubic-bezier(0, 0, 0.58, 1);}' +
              '66.666667% {transform: translate(36px, 36px) rotate(180deg);}' +
              '100% {transform: translate(36px, 36px) rotate(180deg);}' +
            '}' +
            '#ea69YclA0j23_tr {animation: ea69YclA0j23_tr__tr 3000ms linear infinite normal forwards;}' +
            '@keyframes ea69YclA0j23_tr__tr {' +
              '0% {transform: translate(36px, 36px) rotate(0deg);}' +
              '16.666667% {transform: translate(36px, 36px) rotate(90deg); animation-timing-function: cubic-bezier(0, 0, 0.58, 1);}' +
              '33.333333% {transform: translate(36px, 36px) rotate(90deg); animation-timing-function: cubic-bezier(0, 0, 0.58, 1);}' +
              '50% {transform: translate(36px, 36px) rotate(180deg);}' +
              '100% {transform: translate(36px, 36px) rotate(180deg);}' +
            '}' +
          ']]>' +
        '</style>' +
        '<g id="ea69YclA0j22_tr" transform="translate(36,36) rotate(0)">' +
            '<path d="M49.7297,72h-27.4594C8.02429,72,0,63.8244,0,49.7297v-27.4594C0,8.17563,8.02429,0,22.2703,0h27.4594C64.275,0,72,7.87631,72,22.2703v27.4594C72,64.1237,64.275,72,49.7297,72Z" transform="translate(-36,-36)" fill="#1e88e5"/>' +
        '</g>' +
        '<g id="ea69YclA0j23_tr" transform="translate(36,36) rotate(0)">' +
            '<path d="M49.7297,72h-27.4594C8.02429,72,0,63.8244,0,49.7297v-27.4594C0,8.17563,8.02429,0,22.2703,0h27.4594C64.275,0,72,7.87631,72,22.2703v27.4594C72,64.1237,64.275,72,49.7297,72Z" transform="translate(-36,-36)" fill="#43a047"/>' +
        '</g>' +
        '<path d="M49.7297,72h-27.4594C8.02429,72,0,63.8244,0,49.7297v-27.4594C0,8.17563,8.02429,0,22.2703,0h27.4594C64.275,0,72,7.87631,72,22.2703v27.4594C72,64.1237,64.275,72,49.7297,72Z" fill="#263238"/>' +
        '<path d="M46.2564,49.0537c-1.3472,0-2.5476-.4181-3.5412-1.2371-1.1871-.9641-2.1307-2.4016-2.1641-4.0914-.0166-.8536.8803-.8536.8803-.8536s1.4572-.0172,2.1641-.0172c.7069.0172.9136,1.0366.947,1.2924.2734,2.291,1.5238,3.2897,2.4841,3.7458.5769.273.4335,1.1266-.7702,1.1646v-.0035Z" fill="#fff"/>' +
        '<path d="M34.1594,37.4118c-1.1871-.1451-2.9477-.2695-4.0847-.5598-1.844-.4699-1.7939-2.1874-1.7139-2.7472.2234-1.6794.8169-3.2344,1.7306-4.6789c1.137-1.7692,2.7709-3.3242,4.8716-4.589c3.9413-2.3671,9.4531-3.6871,15.5085-3.6871c4.4381,0,9.0696.5978,9.1163.5978.4168.0553.7203.47.7036.9399s-.3368.8294-.7536.8674c-.6736-.0173-1.3305-.0173-1.954-.0173-6.1687,0-10.5602.8674-13.8279,2.7472-3.2211,1.8418-5.4651,4.6616-6.9857,8.836-.16.3628-.6902,2.5122-2.6108,2.2945v-.0035Z" fill="#fff"/>' +
        '<path d="M39.5413,54.6382c-3.061.0657-5.9453-1.3684-8.1293-3.8703-1.8506-2.1182-2.9643-4.2538-3.1711-6.9941-.1267-1.79.6369-2.4085,1.6739-2.3014.7169.0725,2.9477.1831,4.2248.4561.9569.2004,1.5938.7499,1.7539,1.8799.8436,6.0265,4.5115,8.3971,6.6955,8.9085.3835.0899.6202.3456.6069.8052-.0167.4388-.2601,1.0401-3.6512,1.1127l-.0034.0034Z" fill="#fff"/>' +
        '<path d="M30.8214,59.9874c-2.1707.0933-4.2947-.3593-4.9016-.4699-2.5542-.47-4.6949-1.282-6.5288-2.4881-4.3915-2.8819-7.0424-7.972-7.3591-13.9986-.0801-1.4306-.2568-4.164,3.0343-3.9567c1.3571.0761,3.5112.7534,5.0283,1.206c1.884.546,2.7943,2.0527,2.7943,3.542c0,8.4974,7.4258,14.1127,10.6669,14.1127.7735,0,.9569.4769.8636.933-.0734.3629-.2701.978-3.5945,1.1231l-.0034-.0035Z" fill="#fff"/>' +
        '<path d="M19.4942,35.0168c-1.2837-.2384-2.5375-.7878-3.7579-1.1023-3.7746-.971-3.131-4.9173-2.7776-5.9989c3.4345-10.4774,14.3381-13.9814,23.1377-14.9178c8.2861-.8812,16.9556-.2005,25.0316,2.1286.5769.159,2.1674.5564,1.824,1.5239s-1.3005.2938-10.1101.0933c-2.9043-.0656-5.8052.1244-8.7162.5875-4.995.7879-10.13,2.4224-14.258,5.871-1.9907,1.6691-3.7413,3.7978-4.9117,6.3134-.3067.66-.5468,1.3201-.7536,1.9801-.21.698-.997,4.202-4.7049,3.5247l-.0033-.0035Z" fill="#fff"/>' +
        '<path d="M40.618,37.0388c.7069-3.2793,3.848-8.4766,13.5712-8.1172c2.2307.0726,1.2104,1.6483.11,1.6138-5.4985-.197-8.106,3.4763-9.4731,7.2015-.4402,1.1991-1.4438,1.3788-2.7009,1.1645-.8803-.1624-1.8373-.2695-1.5072-1.8626Z" fill="#fff"/>' +
      '</svg>';

      bodyLoadInterval = window.setInterval(function() {
        body = document.getElementsByTagName('body')[0];

        if(body !== undefined) {
          window.clearInterval(bodyLoadInterval);
          body.appendChild(mask);
          mask.appendChild(message);
          message.appendChild(loader);
          document.documentElement.style.opacity = '';
        }
      }, 100);
    },

    unmaskDocument = function() {
      var mask = document.getElementById('crowdin-jipt-mask');

      if(mask) {
        mask.parentNode.removeChild(mask);
      }
    },

    loadResource = function(resourceIdentifier, resourceType, callback) {
      // First check if resource already exists
      var existingResource;
      if (resourceType === 'js') {
        existingResource = document.querySelector(`script[src="${resourceIdentifier}"]`);
      } else if (resourceType === 'css') {
        existingResource = document.querySelector(`link[href="${resourceIdentifier}"]`);
      }

      // If resource exists, trigger callback and return
      if (existingResource) {
        if (callback) {
          setTimeout(callback, 0);
        }
        return;
      }

      var resourceHandler, loaded = false;

      if(resourceType === 'js') {
        resourceHandler = document.createElement('script');

        resourceHandler.setAttribute('type', 'text/javascript');
        resourceHandler.setAttribute('src', resourceIdentifier);
      } else if(resourceType === 'css') {
        resourceHandler = document.createElement('link');

        resourceHandler.setAttribute('rel', 'stylesheet');
        resourceHandler.setAttribute('type', 'text/css');
        resourceHandler.setAttribute('href', resourceIdentifier);
      }

      if(resourceHandler === undefined) {
        return;
      }

      resourceHandler.onload = resourceHandler.onreadystatechange = function() {
        if(!loaded && (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete')) {
          loaded = true;

          if(callback) {
            callback();
          }

          resourceHandler.onload = resourceHandler.onreadystatechange = null;
        }
      };

      document.getElementsByTagName('head')[0].appendChild(resourceHandler);
    },

    htmlspecialchars = function(string) {
      return string ? string.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;') : '';
    },

    jipt = globalThis.jiptExport = {
      callbacks: {},
      phrases: {},

      _phrases: {
        need_load: {},
        was_loaded: {},
        callbacks: [],
        strings_callbacks: {},
        load_timeout: null
      },

      projectLink: null,
      projectId: null,
      projectName: null,
      projectURL: null,

      editor: {
        currentTranslation: null
      },

      target_languages: [],
      workflowSteps: [],

      language: {
        code: null,
        id: 0,
        name: ''
      },

      workflowStep: {
        id: 0,
        type: ''
      },

      source_language: {
        code: null
      },

      user: {
        isLoggedIn: true,
        isLeader: true,
        isManager: false,
        name: '',
        login: '',
        picture: '',
        redirectHash: ''
      },

      regexp: {
        placeholders: {},
        startPhrase: /{crwdns(\d+):(\d)}/i,
        globalStartPhrase: /{crwdns(\d+):\d}/gi,
        globalPhrase: /{crwdns(\d+):(\d)}([\s\S]*?){crwdne\1:\2}/gi,
        exactPhrase: /^{crwdns(\d+):(\d)}([\s\S]*?){crwdne\1:\2}$/i,
        delimiterPart: function(id, plural) {return '{crwdnd' + id + ':' + plural + '}';},
        endPart: function(id, plural) {return '{crwdne' + id + ':' + plural + '}';},
        wrapText: function(text) {return '{crwdns0:0}' + text + '{crwdne0:0}';}
      },

      regexp_new: {
        startPhrase: /crwdns(\d+):(\d)/i,
        globalStartPhrase: /crwdns(\d+):\d/gi,
        globalPhrase: /crwdns(\d+):(\d)([\s\S]*?)crwdne\1:\2/gi,
        exactPhrase: /^crwdns(\d+):(\d)([\s\S]*?)crwdne\1:\2$/i,
        delimiterPart: function(id, plural) {return 'crwdnd' + id + ':' + plural;},
        endPart: function(id, plural) {return 'crwdne' + id + ':' + plural;},
        wrapText: function(text) {return 'crwdns0:0' + text + 'crwdne0:0';}
      },

      status: {
        untranslated: 'untranslated',
        partially_translated: 'partially_translated',
        translated: 'translated',
        partially_approved: 'partially_approved',
        approved: 'approved',
        hidden: 'hidden',
        not_found: 'not_found',
        not_visible_on_step: 'not_visible_on_step',
        file_not_available_for_language: 'file_not_available_for_language'
      },

      // XXX(michaelpolyak): We wish to preview plurals using translations
      // instead of English source strings.
      pluralsPreview: true,
      translatable_placeholders: [],
      translation_preview: {id: false, value: '', plural_id: -1},

      alertFunction: null,
      confirmFunction: null,
      promptFunction: null,

      loginDialog: null,
      editorDialog: null,
      editorAccessStorageDialog: null,
      translationDialog: null,
      dialog_zindex: 2047483647,
      minimized_translation_panel: true,   // jipt translating panel: show or minimize by default
      translations_preview: null,
      translations_highlight: null,
      translations_filter: null,
      touch_optimized: null,

      panel_search_phrase: null,
      rebuild_panel_timeout: null,
      panel_page: 0,
      panel_pages: 1,

      open_hotkeys_settings: false,
      open_editor_settings: false,

      editor_loaded: false,
      editorDialogIframe: null,
      editorAccessStorageDialogIframe: null,
      not_found_warning: '[Unrecognized text]',

      mutationObserver: null,
      isStarting: null,

      loginDialogContent: function() {
        var signup = '';
        if (!config.domain) {
          signup = '<div class="jipt-register-block jipt-help-block">Don\'t have an account? ' +
            '<a target="_blank" href="javascript:void(0)" id="crowdin-join">Sign Up</a>' +
            '</div>';
        }

        return '<div class="crowdin-login-panel" style="display: none;">' +
          '<div id="Jipt_Language">' +
            '<div class="language-group">' +
              '<label for="crowdin-login-language-field">Target Language</label>' +
              '<div>' +
                '<select class="no-margin input-block-level" id="crowdin-login-language-field"></select>' +
              '</div>' +
            '</div>' +
          '</div>' +
          '<div id="Jipt_Workflow_Step">' +
            '<div class="workflow-step-group hide">' +
              '<label class="jipt-s-margin-right" for="crowdin-login-workflow-step-field">Workflow Step:</label>' +
              '<div>' +
                '<select class="no-margin input-block-level" id="crowdin-login-workflow-step-field"></select>' +
              '</div>' +
            '</div>' +
          '</div>' +
          '<div class="jipt-clearfix jipt-login-button-wrapper" style="margin-top: 24px;">' +
            '<h4 class="no-margin-top">Log in with your Crowdin account</h4>' +
              '<div id="regular_login">' +
                '<button type="submit" class="jipt-btn btn-block btn-primary" id="crowdin-jipt-login">Log In</button>' +
                  signup +
              '</div>' +
            '</div>' +
          '</div>' +
          '<div class="crowdin-languages-panel" style="display: none;">' +
            '<div>' +
              '<label for="crowdin-language-field">Target Language</label>' +
              '<div>' +
                '<select class="input-block-level" id="crowdin-language-field"></select>' +
              '</div>' +
            '</div>' +
            '<div class="workflow-step-group hide">' +
              '<label for="crowdin-workflow-step-field">Workflow Step</label>' +
              '<div>' +
                '<select class="input-block-level" id="crowdin-workflow-step-field"></select>' +
              '</div>' +
            '</div>' +
            '<div>' +
              '<button type="button" class="jipt-btn" id="crowdin-select-language-and-step" style="margin-top: 10px;">Select</button>' +
            '</div>' +
          '</div>';
      },

      translationDialogButtons: function() {
        var screenshotBtn = '<li><a id="jipt-screenshot" href="#jipt-screenshot" class="jipt-btn jipt-btn-icon"><i class="jipt-icon-add-screenshot"></i></a></li>';

        return '' +
        '<div class="jipt-dialog-buttons-wrapper">' +
          '<ul id="translation_panel_tabs" class="jipt-tabs">' +
            '<li><a id="show_translations" class="jipt-btn active jipt-btn-icon" href="#jipt-translations"><i class="jipt-icon-home"></i></a></li>' +
            screenshotBtn +
            '<li><a id="show_options" href="#jipt-options" class="jipt-btn jipt-btn-icon"><i class="jipt-icon-options"></i></a></li>' +
          '</ul>' +
          '<div id="translation_panel_paging_wrapper">' +
            '<form id="translation_panel_paging" class="jipt-paging" style="display: none;">' +
              '<input type="text" class="pull-left" id="translation_panel_current_page" size="5">' +
              '<div>' +
                '<a href="#" class="jipt-panel-page jipt-btn jipt-btn-icon" id="translation_panel_prev_page"><i class="jipt-icon-prev"></i></a>' +
                '<a href="#" class="jipt-panel-page jipt-btn jipt-btn-icon" id="translation_panel_next_page"><i class="jipt-icon-next"></i></a>' +
              '</div>' +
            '</form>' +
          '</div>' +
        '</div>';
      },

      translationDialogContent: function() {
        var checked_preview = jipt.translations_preview === true ? ' checked' : '';
        var checked_highlight = jipt.translations_highlight === true ? ' checked' : '';
        var checked_filter = jipt.translations_filter === true ? ' checked' : '';
        var touch_optimized = jipt.touch_optimized === true ? ' checked' : '';
        var login = jipt.user.login;
        var user_name = jipt.user.name;
        var user_picture = jipt.user.picture;
        var user_picture_src = user_picture ? 'src="' + user_picture + '"' : '';
        var profile = Url.getEntryPoint() + (config.domain ? '/u/' : '/profile/' + login);

        var option_preview = '<div class="jipt-control-group">' +
          '<label class="jipt-checkbox"><input type="checkbox" id="jipt-translations-preview"' + checked_preview + '>Preview translations</label>' +
          '</div>';

        var option_highlight = '<div class="jipt-control-group">' +
          '<label class="jipt-checkbox"><input type="checkbox" id="jipt-translations-highlight"' + checked_highlight + '>Highlight</label>' +
          '</div>';

        var option_filter = config.preload_texts ? '<div class="jipt-control-group">' +
          '<label class="jipt-checkbox"><input type="checkbox" id="jipt-translations-filter"' + checked_filter + '>List only texts from the current page</label>' +
          '<div class="jipt-help-block">Home screen will show only strings used on this page.</div>' +
          '</div>' : '';

        var touch_optimized = config.touch_optimized ? '<div class="jipt-control-group">' +
          '<label class="jipt-checkbox"><input type="checkbox" id="jipt-touch-optimized"' + touch_optimized + '>Touch optimized mode</label>' +
          '</div>' : '';

        var keyboard_shortcuts = isMobile ? '' : '<div class="jipt-control-group jipt-settings-toggle">' +
          '<a href="javascript:void(0);" id="jipt-hotkeys-settings">Keyboard Shortcuts</a>' +
          '</div>';

        var jiptWorkflowStep = '';

        if (jipt.workflowSteps.length) {
          jiptWorkflowStep = '<div class="jipt-control-group workflow-step-group">' +
            '<label for="jipt-workflow-step">Workflow Step: </label>' +
            '<div>' +
              '<select class="input-block-level" id="jipt-workflow-step"></select>' +
            '</div>' +
          '</div>';
        }

        return '<div class="crowdin-translation-panel-container">' +
          '<div id="translation_panel_tabs_content" class="jipt-tabs-content">' +
            '<div class="jipt-tab-pane" id="jipt-translations">' +
              '<div class="jipt-input-wrapper">' +
                '<div class="jipt-clear-btn-wrapper">' +
                  '<span class="jipt-icon-search"></span>' +
                  '<input type="text" class="jipt-search-phrase input-block-level" placeholder="Type to search string" />' +
                  '<a class="jipt-clear-btn" href="#" style="display: none;"></a>' +
                '</div>' +
              '</div>' +
              '<div class="jipt-phrases-container no-focus">' +
                '<ul class="jipt-phrases-to-translate">' +
                  '<li class="jipt-loading-msg">Loading...</li>' +
                '</ul>' +
              '</div>' +
            '</div>' +
            '<div class="jipt-tab-pane" id="jipt-options" style="display: none">' +
              '<div class="jipt-options-wrapper">' +
                '<div class="jipt-control-group">' +
                  '<label for="jipt-target-languages">Language</label>' +
                  '<div>' +
                    '<select class="input-block-level" id="jipt-target-languages"></select>' +
                  '</div>' +
                '</div>' +
                jiptWorkflowStep +
                '<div>' +
                  '<button type="button" class="jipt-btn" id="jipt-change-language-and-step">Change</button>' +
                '</div>' +
                '<hr class="jipt-hr">' +
                option_preview +
                option_highlight +
                option_filter +
                touch_optimized +
                '<hr class="jipt-hr jipt-settings-toggle">' +
                '<div class="jipt-control-group jipt-clearfix jipt-settings-toggle">' +
                  '<a class="pull-left jipt_user" target="_blank" href="' + profile + '">' +
                  '<img alt="" ' + user_picture_src + ' class="jipt_user_picture"></a>' +
                  '<div style="margin-left: 54px">' +
                    '<div class="jipt_user_name"><a target="_blank" href="' + profile + '">' + user_name + '</a></div>' +
                      '<button type="button" id="jipt-logout" class="jipt-btn">Log Out</button>' +
                  '</div>' +
                '</div>' +
                '<hr class="jipt-hr jipt-settings-toggle">' +
                '<div class="jipt-control-group jipt-settings-toggle">' +
                  '<a target="_blank" href="' + jipt.projectURL + '">View in Crowdin</a>' +
                '</div>' +
                '<div class="jipt-control-group jipt-settings-toggle">' +
                  '<a href="javascript:void(0);" id="jipt-editor-settings">Editor Settings</a>' +
                '</div>' +
                keyboard_shortcuts +
              '</div>' +
            '</div>' +
            '<div class="jipt-tab-pane" id="jipt-screenshot" style="display: none">' +
              '<div class="jipt-options-wrapper">' +
                '<div>Take a screenshot of the current screen and upload it to Crowdin. All strings will be tagged automatically.</div>' +
                (!jipt.user.isManager ? '<div class="screenshot-status alert-warning">This feature is available only to Crowdin project managers.</div>' : '') +
                '<div class="jipt-clear-btn-wrapper" style="margin-top: 20px">' +
                  '<label for="jipt-search-screenshots">Name</label>' +
                  '<input id="jipt-search-screenshots" type="text" class="input-block-level" placeholder="Type to search screenshots"/>' +
                '</div>' +
                '<div>' +
                  '<label class="jipt-muted jipt-screenshots-label" for="jipt-screenshots">Replace existing screenshot</label>' +
                  '<select class="input-block-level m-0" id="jipt-screenshots" disabled>' +
                    '<option value="0">There is no screenshot with this name</option>' +
                  '</select>' +
                  '<div class="help-block help-small jipt-muted">Sorted by date modified</div>' +
                '</div>' +
                '<div class="screenshot-button-section" style="margin-top: 20px">' +
                  '<div><button type="button" id="make_screenshot" class="jipt-btn disabled" disabled>Add screenshot</button></div>' +
                '</div>' +
                '<div class="screenshot-status" id="screenshot-status"></div>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>';
      },

      init: function() {
        jipt.isStarting = true;
        maskDocument();
        // XXX(aberkan): Moved this initialization here so we can control when it occurs.
        applyUserConfig();

        loadResource(Url.jiptCDN + '/jipt.css?v3', 'css');
        loadResource(Url.jiptCDN + '/lib/h2c.min.js', 'js');
        // XXX(whns): Commented out to prevent the editor from being repositioned
        // to ~2x the screen width during jipt-interface's focusEditor() call.
        // loadResource(Url.jiptCDN + '/lib/ResizeSensor.js', 'js');
        loadResource(Url.jiptCDN + '/lib/jquery.min.js', 'js', function() {
          $ = $ || jQuery.noConflict(true); // $ is not a global variable

          jipt.init_plugins();
          jipt.init_editor_listener();

          $(document).ready(function() {
            jipt.init_access_storage_dialog();
          });
        });

        document.addEventListener('scroll', function (event) {
          jipt.active_translation && jipt.show_translation_badge(jipt.active_translation);
        }, true /*Capture event*/);
      },

      init_plugins: function() {
        jipt.init_jipt_dialog();
        jipt.init_mouse_touch_events();
        jipt.init_drags();
        jipt.init_center_position();
      },

      init_icu: function() {
        loadResource(Url.jiptCDN + '/lib/moment.min.js', 'js');
        loadResource(Url.jiptCDN + '/lib/Intl.complete.min.js', 'js');
        loadResource(Url.jiptCDN + '/lib/messageformat.light.min.js', 'js');
      },

      init_jipt_dialog: function() {
        const collapseWidth = 550;
        const expandWidth = 800;

        $.fn.jiptDialog = function(options) {
          options = $.extend({
            modal: false,
            position: '',
            save_position: false,
            drags: true,
            resize: false,
            fixed: true,
            title_pane: '',
            minimize_btn: true,
            close_btn: true,
            minimized: false,
            icon: '',
            buttons_pane: '',
            width: 'auto',
            height: 'auto',
            parent_height: null,
            save_height: false,
            custom_class: '',
            close_callback: '',
            iframe: false,
            action: 'init'
          }, options);

          var dialog_inner = $(this);
          var dialog = {};
          var content = {};

          if(options.action !== 'init') {
            dialog = dialog_inner.parent();

            if(!dialog.hasClass('jipt-dialog')) {
              console.warn('Crowdin In-Context dialog: seems that dialog is not initialized.');
              return;
            }
          }

          switch(options.action) {
            case 'init':
              init();
              return content;
            case 'open':
              open();
              break;
            case 'close':
              close();
              break;
            case 'destroy':
              destroy();
              break;
            case 'toggle_minimized':
              toggle_minimized();
              break;
            case 'toggle_minimized_show':
              toggle_minimized(true);
              break;
            case 'toggle_resize':
              toggle_resize();
              break
            case 'center':
              dialog.center();
              break;
            case 'is_visible':
              return dialog.is(':visible');
            case 'move_to_front':
              move_to_front();
              break;
            default:
              console.warn('Crowdin JIPT dialog: unknown action :(');
              return;
          }

          function createOverlay() {
            if(!$('#jipt-modal-mask').length) {
              $($('<div>').attr('id', 'jipt-modal-mask').css('display', 'none')).appendTo('body');
            }
          }

          function init() {
            if(dialog_inner.hasClass('jipt-dialog-content')) {
              console.warn('Crowdin In-Context dialog: seems that dialog is already initialized.');
              return;
            }

            dialog = $('<div data-html2canvas-ignore="true" class="jipt-dialog crowdin-jipt ' + options.custom_class + '" style="display:none">');
            dialog_inner.addClass('jipt-dialog-content');
            dialog.appendTo('body');

            if(options.iframe) {
              var iframe_contents = dialog_inner.html();
              var iframe = $('<iframe class="crowdin-jipt" frameBorder="0"/>');
              iframe.css({
                'width': '100%',
                'display': 'block',
                'overflow': 'hidden',
                'height': options.height
              });
              dialog_inner.empty().append(iframe).css('padding', 0);
              dialog.html(dialog_inner);
              var iframe_doc = iframe.contents()[0];
              iframe_doc.open();
              iframe_doc.write('<!doctype html>' +
                '<html>' +
                '<head>' +
                '<link href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700,900" rel="stylesheet">' +
                '<link rel="stylesheet" type="text/css" href="' + Url.jiptCDN + '/jipt.css' + '"/>' +
                '</head>' +
                '<body style="margin: 0" id ="' + dialog_inner.get(0).id + '" class="jipt-dialog-content crowdin-jipt ' + options.custom_class + '">' + iframe_contents + '</body>' +
                '</html>');
              iframe_doc.close();

              content = iframe.contents();
              content.mousedown(function(e) {
                if($(e.target).closest('.no-focus').length === 0) {
                  move_to_front();
                }
              });
            } else {
              dialog.html(dialog_inner);
              content = dialog_inner;
            }

            var dialog_id = dialog_inner.attr('id');
            var icon_class = options.icon ? ' jipt-dialog-icon-' + options.icon : '';
            var close_btn = options.close_btn ?
                '<a href="#" data-id="#' + dialog_id + '" class="jipt-close-btn jipt-dialog-close">' +
                    '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">' +
                        '<path fill="currentColor" d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/>' +
                    '</svg>' +
                  '</a>' :
                '';
            var minimize_btn = options.minimize_btn ? '<a href="#" data-id="#' + dialog_id + '" class="jipt-minimize-btn jipt-dialog-minimize"><span class="jipt-icon-minimize"></span></a>' : '';
            var resize_btn = options.resize_btn ? '<a href="#" data-id="#' + dialog_id + '" class="jipt-resize-btn"><span class="jipt-icon-expand-content"></span></a>' : '';
            var title_pane = '';
            var title_buttons = '';
            var buttons_pane = '';

            if(options.title_pane) {
              title_pane = '<div class="jipt-dialog-title jipt-dialog-drags jipt-clearfix' + icon_class + '">' + options.title_pane + '</div>';
            }

            if(close_btn || minimize_btn || resize_btn) {
              title_buttons = '<div class="jipt-dialog-title-buttons jipt-clearfix">' + close_btn + minimize_btn + resize_btn + '</div>';
            }

            dialog_inner.before(title_buttons + title_pane);

            if(options.buttons_pane) {
              buttons_pane = '<div class="jipt-dialog-buttons jipt-dialog-drags jipt-clearfix">' + options.buttons_pane + '</div>';
              dialog_inner.after(buttons_pane);
            }

            dialog.css('position', options.fixed === true ? 'fixed' : 'absolute');
            dialog.width(options.width === 'auto' ? dialog.width() : options.width);

            if(options.parent_height) {
              dialog.height(options.parent_height === 'auto' ? dialog.width() : options.parent_height);
            }

            dialog_inner.height(options.height);
            dialog_inner.append('<div class="jipt-dialog-content-mask" style="display: none; height:' + dialog_inner.height() + 'px;"><div>');

            if(options.save_height && !options.iframe) {
              dialog.data('save_height', true);
            }

            if(options.modal) {
              dialog.data('modal', true);
              createOverlay();
            }

            if(options.drags && options.title_pane) {
              var position  = options.fixed === true ? 'fixed' : 'absolute';

              dialog.udraggable({
                position: position,
                handle: '.jipt-dialog-drags'
              });
            }

            if(options.resize) {
              dialog.addClass('jipt-dialog-resize');
              dialog_inner.before('<div class="jipt-dialog-mask mask-hidden"></div>');
            }

            if(options.minimized) {
              if(Storage.get(dialog_inner.attr('id') + '_min') !== 'no') {
                dialog.addClass('jipt-dialog-minimized');
              }
            }

            dialog.find('.jipt-dialog-close').click(function() {
              dialog_inner.jiptDialog({action: 'close'});
              return false;
            });

            dialog.find('.jipt-dialog-minimize').click(function() {
              dialog_inner.jiptDialog({action: 'toggle_minimized'});
              return false;
            });

            dialog.find('.jipt-resize-btn').click(function() {
              dialog_inner.jiptDialog({action: 'toggle_resize'});
              return false;
            });

            dialog.find('.jipt-dialog-title').on('utap', function() {
              if(dialog.hasClass('jipt-dialog-minimized')) {
                dialog_inner.jiptDialog({action: 'toggle_minimized_show'});
              }
            });

            dialog.find('.jipt-dialog-title #translation_panel_tabs_minimized .jipt-btn').on('click', function(e) {
              if(dialog.hasClass('jipt-dialog-minimized')) {
                dialog_inner.jiptDialog({action: 'toggle_minimized'});
                $(e.target).trigger('click');
              }
            });

            dialog.on('jipt_dialog_close', function() {
              if(options.close_callback) {
                options.close_callback();
              }
            });

            if(options.resize_btn) {
              new ResizeObserver(function() {
                var width = dialog.width();
                var resizeBtnClassName = dialog.find('.jipt-resize-btn span').attr('class');

                var className = width < expandWidth ? 'jipt-icon-expand-content' : 'jipt-icon-collapse-content';

                if(resizeBtnClassName !== className) {
                  dialog.find('.jipt-resize-btn span').removeClass(resizeBtnClassName).addClass(className);
                }
              }).observe(dialog[0]);
            }

            options.save_position ? restorePosition() : setPosition();
          }

          function toggle_resize() {
            var resizeBtn = dialog.find('.jipt-resize-btn > span');

            if(resizeBtn.hasClass('jipt-icon-expand-content')) {
              dialog.width(expandWidth);
              resizeBtn.removeClass('jipt-icon-expand-content').addClass('jipt-icon-collapse-content');
            } else if(resizeBtn.hasClass('jipt-icon-collapse-content')) {
              dialog.width(collapseWidth);
              resizeBtn.removeClass('jipt-icon-collapse-content').addClass('jipt-icon-expand-content');
            }
          }

          function toggle_minimized(show_only) {
            var offset;

            if(dialog.hasClass('jipt-dialog-minimized')) {
              dialog.removeClass('jipt-dialog-minimized');
              if(Storage.get(dialog_inner.attr('id') + '_normal')) {
                offset = JSON.parse(Storage.get(dialog_inner.attr('id') + '_normal'));

                dialog.css(offset);
              } else {
                dialog.css('top', $(window).height() - dialog.outerHeight() - 10 + 'px');
              }
            } else if(!show_only) {
              var offset_top = dialog.offset().top - $(window).scrollTop();
              var offset_left = dialog.offset().left - $(window).scrollLeft();

              offset = {top: offset_top, left: offset_left}; // relative to window

              Storage.save(dialog_inner.attr('id') + '_normal', JSON.stringify(offset));
              dialog.addClass('jipt-dialog-minimized');
            }
          }

          function setPosition() {
            var top, left;

            switch(options.position) {
              case 'center':
                if (options.fixed === false) {
                  dialog.center(window, true);
                } else {
                  dialog.center();
                }
                break;
              case 'bottom-left':
                top = (($(window).height() - dialog.outerHeight()) - 10) + $(window).scrollTop();

                dialog.css({
                  top: (top < 0 ? 0 : top) + 'px',
                  left: 10 + 'px'
                });
                break;
              case 'bottom-right':
                top = (($(window).height() - dialog.outerHeight()) - 10) + $(window).scrollTop();
                left = (($(window).width() - dialog.outerWidth()) - 10) + $(window).scrollLeft();

                dialog.css({
                  top: (top < 0 ? 0 : top) + 'px',
                  left: (left > 0 ? 0 : left) + 'px'
                });
                break;
              default:
                if (options.fixed === false) {
                  dialog.center(window, true);
                } else {
                  dialog.center();
                }
            }
          }

          function savePosition() {
            $(window).unload(function() {
              if(dialog.is(':visible')) {
                var offset_top = dialog.offset().top - $(window).scrollTop();
                var offset_left = dialog.offset().left - $(window).scrollLeft();
                var offset = {top: offset_top, left: offset_left}; // relative to window

                Storage.save(dialog_inner.attr('id'), JSON.stringify(offset));
                if(dialog.hasClass('jipt-dialog-minimized')) {
                  Storage.save(dialog_inner.attr('id') + '_min', 'yes');
                } else {
                  Storage.save(dialog_inner.attr('id') + '_min', 'no');
                }
              }
            });
          }

          function restorePosition() {
            if (Storage.get(dialog_inner.attr('id') + '_min') === 'yes') {
              dialog.addClass('jipt-dialog-minimized');
            }
            if (Storage.get(dialog_inner.attr('id'))) {
              var offset = JSON.parse(Storage.get(dialog_inner.attr('id')));
              var min_offset_left = 0;
              var min_offset_top = 0;
              var max_offset_left = $(window).width() - dialog.outerWidth();
              var max_offset_top = $(window).height() - dialog.outerHeight();

              if(offset.left < min_offset_left) {
                offset.left = min_offset_left;
              } else if (offset.left > max_offset_left) {
                offset.left = max_offset_left;
              }

              if(offset.top < min_offset_top) {
                offset.top = min_offset_top;
              } else if (offset.top > max_offset_top) {
                offset.top = max_offset_top;
              }

              dialog.css(offset);
              savePosition();
            } else {
              setPosition();
              savePosition();
            }
          }

          function open() {
            if(dialog.data('modal')) {
              $('#jipt-modal-mask').css('z-index', jipt.dialog_zindex += 1).show();
              $('html').addClass('jipt-no-scroll');
            }

            if(options.position !== '' && !dialog.is(':visible')) {
              setPosition();
            }

            move_to_front();
            dialog.css('visibility', 'visible');
            dialog.css('display', 'block');

            if(dialog.data('save_height')) {
              dialog_inner.
              height(dialog_inner.height()).
              css('overflow', 'auto');
            }
          }

          function close() {
            if(dialog.data('modal')) {
              $('html').removeClass('jipt-no-scroll');
              $('#jipt-modal-mask').hide();
            }

            dialog.css('display', 'none');
            dialog.trigger('jipt_dialog_close');
          }

          function destroy() {
            if(dialog.data('modal')) {
              $('#jipt-modal-mask').hide();
            }

            dialog.remove();
          }

          function move_to_front() {
            // XXX(whns): Commented out to prevent the editor from being repositioned
            // to ~2x the screen width during jipt-interface's focusEditor() call.
            // var time, type;
            // var sensor =  typeof __ResizeSensor !== 'undefined' && new __ResizeSensor(dialog, function(e) {
            //   if (type === 'move_to_front') {
            //     dialog.find('.jipt-dialog-mask').removeClass('mask-hidden');
            //     clearTimeout(time);
            //     time = setTimeout(function() {
            //       $(document).on('mouseup', function() {
            //         dialog.find('.jipt-dialog-mask').addClass('mask-hidden');
            //         sensor.detach(dialog);
            //       });
            //     }, 100);
            //   }
            //   type = options.action;
            // });

            dialog.css('z-index', jipt.dialog_zindex += 1).
            siblings('.jipt-dialog').
            removeClass('active-dialog').
            end().addClass('active-dialog');
          }
        };

        $(document).on('mousedown utapstart', function(e) {
          var dialog = $(e.target).closest('.jipt-dialog');

          if(dialog.length) {
            dialog.find('.jipt-dialog-content').jiptDialog({action: 'move_to_front'});
          } else {
            $('.jipt-dialog').removeClass('active-dialog');
          }
        });
      },

      init_mouse_touch_events: function() {
        /* Jquery plugin for unified mouse and touch events
       * Version 0.3.2
       * Modified by Anton
       * https://github.com/mmikowski/jquery.event.ue/blob/master/jquery.event.ue.js
      */
        var
          $Special        = $.event.special,  // shortcut for special event
          motionMapMap    = {},         // map of pointer motions by cursor
          isMoveBound     = false,      // flag if move handlers bound
          pxPinchZoom     = -1,         // distance between pinch-zoom points
          optionKey       = 'ue_bound', // data key for storing options
          doDisableMouse  = false,      // flag to discard mouse input
          defaultOptMap   = {           // Default option hash
            bound_ns_map  : {},         // namspace hash e.g. bound_ns_map.utap.fred
            wheel_ratio   : 15,         // multiplier for mousewheel delta
            px_radius     : 1,          // 'distance' dragged before dragstart
            ignore_class  : ':input',   // 'not' suppress matching elements
            tap_time      : 200,        // millisecond max time to consider tap
            held_tap_time : 300         // millisecond min time to consider taphold
          },
          callbackList  = [],           // global callback stack
          zoomMouseNum  = 1,            // multiplier for mouse zoom
          zoomTouchNum  = 4,            // multiplier for touch zoom

          boundList, Ue,
          motionDragId,  motionHeldId, motionDzoomId,
          motion1ZoomId, motion2ZoomId,

          checkMatchVal, removeListVal,  pushUniqVal,   makeListPlus,
          fnHeld,        fnMotionStart,  fnMotionMove,
          fnMotionEnd,   onMouse,        onTouch,
          onMousewheel
        ;
        //----------------- END MODULE SCOPE VARIABLES ---------------

        //------------------- BEGIN UTILITY METHODS ------------------
        // Begin utiltity /makeListPlus/
        // Returns an array with much desired methods:
        //   * remove_val(value) : remove element that matches
        //     the provided value. Returns number of elements
        //     removed.
        //   * match_val(value)  : shows if a value exists
        //   * push_uniq(value)  : pushes a value onto the stack
        //     iff it does not already exist there
        // Note: the reason I need this is to compare objects to
        //   objects (perhaps jQuery has something similar?)
        checkMatchVal = function ( data ) {
          var match_count = 0, idx;
          for ( idx = this.length; idx; 0 ) {
            if ( this[--idx] === data ) { match_count++; }
          }
          return match_count;
        };
        removeListVal = function ( data ) {
          var removed_count = 0, idx;
          for ( idx = this.length; idx; 0 ) {
            if ( this[--idx] === data ) {
              this.splice(idx, 1);
              removed_count++;
              idx++;
            }
          }
          return removed_count;
        };
        pushUniqVal = function ( data ) {
          if ( checkMatchVal.call(this, data ) ) { return false; }
          this.push( data );
          return true;
        };
        // primary utility
        makeListPlus = function ( input_list ) {
          if ( input_list && $.isArray(input_list) ) {
            if ( input_list.remove_val ) {
              console.warn( 'The array appears to already have listPlus capabilities' );
              return input_list;
            }
          }
          else {
            input_list = [];
          }
          input_list.remove_val = removeListVal;
          input_list.match_val  = checkMatchVal;
          input_list.push_uniq  = pushUniqVal;

          return input_list;
        };
        // End utility /makeListPlus/
        //-------------------- END UTILITY METHODS -------------------

        //--------------- BEGIN JQUERY SPECIAL EVENTS ----------------
        // Unique array for bound objects
        boundList = makeListPlus();

        // Begin define special event handlers
        Ue = {
          setup : function( data, a_names, fn_bind ) {
            var
              elem_this = this,
              $to_bind  = $(elem_this),
              seen_map    = {},
              option_map, idx, namespace_key, ue_namespace_code, namespace_list
            ;

            // if previous related event bound do not rebind, but do add to
            // type of event bound to this element, if not already noted
            if ( $.data( this, optionKey ) ) { return; }

            option_map = {};
            $.extend( true, option_map, defaultOptMap );
            $.data( elem_this, optionKey, option_map );

            namespace_list = makeListPlus(a_names.slice(0));
            if ( ! namespace_list.length
              || namespace_list[0] === ""
            ) { namespace_list = ["000"]; }

            NSPACE_00:
              for ( idx = 0; idx < namespace_list.length; idx++ ) {
                namespace_key = namespace_list[idx];

                if ( ! namespace_key ) { continue NSPACE_00; }
                if ( seen_map.hasOwnProperty(namespace_key) ) { continue NSPACE_00; }

                seen_map[namespace_key] = true;

                ue_namespace_code = '.__ue' + namespace_key;

                $to_bind.bind( 'mousedown'  + ue_namespace_code, onMouse  );
                $to_bind.bind( 'touchstart' + ue_namespace_code, onTouch );
                $to_bind.bind( 'mousewheel' + ue_namespace_code, onMousewheel );
              }

            boundList.push_uniq( elem_this ); // record as bound element

            if ( ! isMoveBound ) {
              // console.log('first element bound - adding global binds');
              $(document).bind( 'mousemove.__ue',   onMouse );
              $(document).bind( 'touchmove.__ue',   onTouch );
              $(document).bind( 'mouseup.__ue'  ,   onMouse );
              $(document).bind( 'touchend.__ue' ,   onTouch );
              $(document).bind( 'touchcancel.__ue', onTouch );
              isMoveBound = true;
            }
          },

          // arg_map.type = string - name of event to bind
          // arg_map.data = poly - whatever (optional) data was passed when binding
          // arg_map.namespace = string - A sorted, dot-delimited list of namespaces
          //   specified when binding the event
          // arg_map.handler  = fn - the event handler the developer wishes to be bound
          //   to the event.  This function should be called whenever the event
          //   is triggered
          // arg_map.guid = number - unique ID for event handler, provided by jQuery
          // arg_map.selector = string - selector used by 'delegate' or 'live' jQuery
          //   methods.  Only available when these methods are used.
          //
          // this - the element to which the event handler is being bound
          // this always executes immediate after setup (if first binding)
          add : function ( arg_map ) {
            var
              elem_this       = this,
              option_map      = $.data( elem_this, optionKey ),
              namespace_str   = arg_map.namespace,
              event_type      = arg_map.type,
              bound_ns_map, namespace_list, idx, namespace_key
            ;
            if ( ! option_map ) { return; }

            bound_ns_map  = option_map.bound_ns_map;

            if ( ! bound_ns_map[event_type] ) {
              // this indicates a non-namespaced entry
              bound_ns_map[event_type] = {};
            }

            if ( ! namespace_str ) { return; }

            namespace_list = namespace_str.split('.');

            for ( idx = 0; idx < namespace_list.length; idx++ ) {
              namespace_key = namespace_list[idx];
              bound_ns_map[event_type][namespace_key] = true;
            }
          },

          remove : function ( arg_map ) {
            var
              elem_bound     = this,
              option_map     = $.data( elem_bound, optionKey ),
              bound_ns_map   = option_map.bound_ns_map,
              event_type     = arg_map.type,
              namespace_str  = arg_map.namespace,
              namespace_list, idx, namespace_key
            ;

            if ( ! bound_ns_map[event_type] ) { return; }

            // No namespace(s) provided:
            // Remove complete record for custom event type (e.g. utap)
            if ( ! namespace_str ) {
              delete bound_ns_map[event_type];
              return;
            }

            // Namespace(s) provided:
            // Remove namespace flags from each custom event typei (e.g. utap)
            // record.  If all claimed namespaces are removed, remove
            // complete record.
            namespace_list = namespace_str.split('.');

            for ( idx = 0; idx < namespace_list.length; idx++ ) {
              namespace_key = namespace_list[idx];
              if (bound_ns_map[event_type][namespace_key]) {
                delete bound_ns_map[event_type][namespace_key];
              }
            }

            if ( $.isEmptyObject( bound_ns_map[event_type] ) ) {
              delete bound_ns_map[event_type];
            }
          },

          teardown : function( a_names ) {
            var
              elem_bound   = this,
              $bound       = $(elem_bound),
              option_map   = $.data( elem_bound, optionKey ),
              bound_ns_map = option_map.bound_ns_map,
              idx, namespace_key, ue_namespace_code, namespace_list
            ;

            // do not tear down if related handlers are still bound
            if ( ! $.isEmptyObject( bound_ns_map ) ) { return; }

            namespace_list = makeListPlus(a_names);
            namespace_list.push_uniq('000');

            NSPACE_01:
              for ( idx = 0; idx < namespace_list.length; idx++ ) {
                namespace_key = namespace_list[idx];

                if ( ! namespace_key ) { continue NSPACE_01; }

                ue_namespace_code = '.__ue' + namespace_key;
                $bound.unbind( 'mousedown'  + ue_namespace_code );
                $bound.unbind( 'touchstart' + ue_namespace_code );
                $bound.unbind( 'mousewheel' + ue_namespace_code );
              }

            $.removeData( elem_bound, optionKey );

            // Unbind document events only after last element element is removed
            boundList.remove_val(this);
            if ( boundList.length === 0 ) {
              // console.log('last bound element removed - removing global binds');
              $(document).unbind( 'mousemove.__ue');
              $(document).unbind( 'touchmove.__ue');
              $(document).unbind( 'mouseup.__ue');
              $(document).unbind( 'touchend.__ue');
              $(document).unbind( 'touchcancel.__ue');
              isMoveBound = false;
            }
          }
        };
        // End define special event handlers
        //--------------- BEGIN JQUERY SPECIAL EVENTS ----------------

        //------------------ BEGIN MOTION CONTROLS -------------------
        // Begin motion control /fnHeld/
        fnHeld = function ( arg_map ) {
          var
            timestamp         = +new Date(),
            motion_id    = arg_map.motion_id,
            motion_map   = arg_map.motion_map,
            bound_ns_map = arg_map.bound_ns_map,
            event_ue
          ;

          delete motion_map.idto_tapheld;

          if ( ! motion_map.do_allow_tap ) { return; }

          motion_map.px_end_x     = motion_map.px_start_x;
          motion_map.px_end_y     = motion_map.px_start_y;
          motion_map.ms_timestop  = timestamp;
          motion_map.ms_elapsed   = timestamp - motion_map.ms_timestart;

          if ( bound_ns_map.uheld ) {
            event_ue     = $.Event('uheld');
            $.extend( event_ue, motion_map );
            $(motion_map.elem_bound).trigger(event_ue);
          }

          // remove tracking, as we want no futher action on this motion
          if ( bound_ns_map.uheldstart ) {
            event_ue     = $.Event('uheldstart');
            $.extend( event_ue, motion_map );
            $(motion_map.elem_bound).trigger(event_ue);
            motionHeldId = motion_id;
          }
          else {
            delete motionMapMap[motion_id];
          }
        };
        // End motion control /fnHeld/


        // Begin motion control /fnMotionStart/
        fnMotionStart = function ( arg_map ) {
          var
            motion_id      = arg_map.motion_id,
            event_src      = arg_map.event_src,
            request_dzoom  = arg_map.request_dzoom,

            option_map     = $.data( arg_map.elem, optionKey ),
            bound_ns_map   = option_map.bound_ns_map,
            $target        = $(event_src.target ),
            do_zoomstart   = false,
            motion_map, cb_map, do_allow_tap, event_ue
          ;

          // this should never happen, but it does
          if ( motionMapMap[ motion_id ] ) { return; }

          if ( request_dzoom && ! bound_ns_map.uzoomstart ) { return; }

          // :input selector includes text areas
          if ( $target.is( option_map.ignore_class ) || $target.is( 'a' ) || $target.parent().is( 'a' ) ) { return; }

          event_src.preventDefault();

          do_allow_tap = bound_ns_map.utap
          || bound_ns_map.uheld || bound_ns_map.uheldstart
            ? true : false;

          cb_map = callbackList.pop();

          while ( cb_map ) {
            if ( $target.is( cb_map.selector_str )
              || $( arg_map.elem ).is( cb_map.selector_str )
            ) {
              if ( cb_map.callback_match ) {
                cb_map.callback_match( arg_map );
              }
            }
            else {
              if ( cb_map.callback_nomatch ) {
                cb_map.callback_nomatch( arg_map );
              }
            }
            cb_map = callbackList.pop();
          }

          motion_map = {
            do_allow_tap : do_allow_tap,
            elem_bound   : arg_map.elem,
            elem_target  : event_src.target,
            ms_elapsed   : 0,
            ms_timestart : event_src.timeStamp,
            ms_timestop  : undefined,
            option_map   : option_map,
            orig_target  : event_src.target,
            px_current_x : event_src.clientX,
            px_current_y : event_src.clientY,
            px_end_x     : undefined,
            px_end_y     : undefined,
            px_start_x   : event_src.clientX,
            px_start_y   : event_src.clientY,
            timeStamp    : event_src.timeStamp
          };

          motionMapMap[ motion_id ] = motion_map;

          event_ue = $.Event('utapstart');
          $.extend( event_ue, motion_map );
          $(motion_map.elem_bound).trigger(event_ue);

          if ( bound_ns_map.uzoomstart ) {
            if ( request_dzoom ) {
              motionDzoomId = motion_id;
            }
            else if ( ! motion1ZoomId ) {
              motion1ZoomId = motion_id;
            }
            else if ( ! motion2ZoomId ) {
              motion2ZoomId = motion_id;
              event_ue = $.Event('uzoomstart');
              do_zoomstart = true;
            }

            if ( do_zoomstart ) {
              event_ue = $.Event( 'uzoomstart' );
              motion_map.px_delta_zoom = 0;
              $.extend( event_ue, motion_map );
              $(motion_map.elem_bound).trigger(event_ue);
              return;
            }
          }

          if ( bound_ns_map.uheld || bound_ns_map.uheldstart ) {
            motion_map.idto_tapheld = setTimeout(
              function() {
                fnHeld({
                  motion_id  : motion_id,
                  motion_map   : motion_map,
                  bound_ns_map : bound_ns_map
                });
              },
              option_map.held_tap_time
            );
          }
        };
        // End motion control /fnMotionStart/

        // Begin motion control /fnMotionMove/
        fnMotionMove  = function ( arg_map ) {
          var
            motion_id   = arg_map.motion_id,
            event_src   = arg_map.event_src,
            do_zoommove = false,
            motion_map, option_map, bound_ns_map,
            event_ue, px_pinch_zoom, px_delta_zoom,
            mzoom1_map, mzoom2_map
          ;

          if ( ! motionMapMap[motion_id] ) { return; }

          event_src.preventDefault();

          motion_map   = motionMapMap[motion_id];
          option_map   = motion_map.option_map;
          bound_ns_map = option_map.bound_ns_map;

          motion_map.timeStamp    = event_src.timeStamp;
          motion_map.elem_target  = event_src.target;
          motion_map.ms_elapsed   = event_src.timeStamp - motion_map.ms_timestart;

          motion_map.px_delta_x   = event_src.clientX - motion_map.px_current_x;
          motion_map.px_delta_y   = event_src.clientY - motion_map.px_current_y;

          motion_map.px_current_x = event_src.clientX;
          motion_map.px_current_y = event_src.clientY;

          // native event object override
          motion_map.timeStamp    = event_src.timeStamp;

          // disallow tap if outside of zone or time elapsed
          // we use this for other events, so we do it every time
          if ( motion_map.do_allow_tap ) {
            if ( Math.abs(motion_map.px_delta_x) > option_map.px_radius
              || Math.abs(motion_map.pd_delta_y) > option_map.px_radius
              || motion_map.ms_elapsed           > option_map.tap_time
            ) { motion_map.do_allow_tap = false; }
          }

          if ( motion1ZoomId && motion2ZoomId
            && ( motion_id === motion1ZoomId
              || motion_id === motion2ZoomId
            )) {
            motionMapMap[motion_id] = motion_map;
            mzoom1_map = motionMapMap[motion1ZoomId];
            mzoom2_map = motionMapMap[motion2ZoomId];

            px_pinch_zoom = Math.floor(
              Math.sqrt(
                Math.pow((mzoom1_map.px_current_x - mzoom2_map.px_current_x),2)
                + Math.pow((mzoom1_map.px_current_y - mzoom2_map.px_current_y),2)
              ) +0.5
            );

            if ( pxPinchZoom === -1 ) { px_delta_zoom = 0; }
            else { px_delta_zoom = ( px_pinch_zoom - pxPinchZoom ) * zoomTouchNum;}

            // save value for next iteration delta comparison
            pxPinchZoom  = px_pinch_zoom;
            do_zoommove  = true;
          }
          else if ( motionDzoomId === motion_id ) {
            if ( bound_ns_map.uzoommove ) {
              px_delta_zoom = motion_map.px_delta_y * zoomMouseNum;
              do_zoommove = true;
            }
          }

          if ( do_zoommove ){
            event_ue = $.Event('uzoommove');
            motion_map.px_delta_zoom = px_delta_zoom;
            $.extend( event_ue, motion_map );
            $(motion_map.elem_bound).trigger(event_ue);
            return;
          }

          if ( motionHeldId === motion_id ) {
            if ( bound_ns_map.uheldmove ) {
              event_ue = $.Event('uheldmove');
              $.extend( event_ue, motion_map );
              $(motion_map.elem_bound).trigger(event_ue);
            }
          }
          else if ( motionDragId === motion_id ) {
            if ( bound_ns_map.udragmove ) {
              event_ue = $.Event('udragmove');
              $.extend( event_ue, motion_map );
              $(motion_map.elem_bound).trigger(event_ue);
            }
          }

          if ( ! motionDragId
            && ! motionHeldId
            && bound_ns_map.udragstart
            && motion_map.do_allow_tap === false
          ) {
            motionDragId = motion_id;
            event_ue = $.Event('udragstart');
            $.extend( event_ue, motion_map );
            $(motion_map.elem_bound).trigger(event_ue);

            if ( motion_map.idto_tapheld ) {
              clearTimeout(motion_map.idto_tapheld);
              delete motion_map.idto_tapheld;
            }
          }
        };
        // End motion control /fnMotionMove/

        // Begin motion control /fnMotionEnd/
        fnMotionEnd   = function ( arg_map ) {
          var
            motion_id    = arg_map.motion_id,
            event_src    = arg_map.event_src,
            do_zoomend   = false,
            motion_map, option_map, bound_ns_map, event_ue
          ;

          doDisableMouse = false;

          if ( ! motionMapMap[motion_id] ) { return; }

          motion_map   = motionMapMap[motion_id];
          option_map   = motion_map.option_map;
          bound_ns_map = option_map.bound_ns_map;

          motion_map.elem_target  = event_src.target;
          motion_map.ms_elapsed   = event_src.timeStamp - motion_map.ms_timestart;
          motion_map.ms_timestop  = event_src.timeStamp;

          if ( motion_map.px_current_x ) {
            motion_map.px_delta_x   = event_src.clientX - motion_map.px_current_x;
            motion_map.px_delta_y   = event_src.clientY - motion_map.px_current_y;
          }

          motion_map.px_current_x = event_src.clientX;
          motion_map.px_current_y = event_src.clientY;

          motion_map.px_end_x     = event_src.clientX;
          motion_map.px_end_y     = event_src.clientY;

          // native event object override
          motion_map.timeStamp    = event_src.timeStamp;

          event_ue = $.Event('utapend');
          $.extend( event_ue, motion_map );
          $(motion_map.elem_bound).trigger(event_ue);

          // clear-out any long-hold tap timer
          if ( motion_map.idto_tapheld ) {
            clearTimeout(motion_map.idto_tapheld);
            delete motion_map.idto_tapheld;
          }

          // trigger utap
          if ( bound_ns_map.utap
            && motion_map.ms_elapsed   <= option_map.tap_time
            && motion_map.do_allow_tap
          ) {
            event_ue = $.Event('utap');
            $.extend( event_ue, motion_map );
            $(motion_map.elem_bound).trigger(event_ue);
          }

          // trigger udragend
          if ( motion_id === motionDragId ) {
            if ( bound_ns_map.udragend ) {
              event_ue = $.Event('udragend');
              $.extend( event_ue, motion_map );
              $(motion_map.elem_bound).trigger(event_ue);
            }
            motionDragId = undefined;
          }

          // trigger heldend
          if ( motion_id === motionHeldId ) {
            if ( bound_ns_map.uheldend ) {
              event_ue = $.Event('uheldend');
              $.extend( event_ue, motion_map );
              $(motion_map.elem_bound).trigger(event_ue);
            }
            motionHeldId = undefined;
          }

          // trigger uzoomend
          if ( motion_id === motionDzoomId ) {
            do_zoomend = true;
            motionDzoomId = undefined;
          }

          // cleanup zoom info
          else if ( motion_id === motion1ZoomId ) {
            if ( motion2ZoomId ) {
              motion1ZoomId = motion2ZoomId;
              motion2ZoomId = undefined;
              do_zoomend = true;
            }
            else { motion1ZoomId = undefined; }
            pxPinchZoom  = -1;
          }
          if ( motion_id === motion2ZoomId ) {
            motion2ZoomId = undefined;
            pxPinchZoom  = -1;
            do_zoomend   = true;
          }

          if ( do_zoomend && bound_ns_map.uzoomend ) {
            event_ue = $.Event('uzoomend');
            motion_map.px_delta_zoom = 0;
            $.extend( event_ue, motion_map );
            $(motion_map.elem_bound).trigger(event_ue);
          }
          // remove pointer from consideration
          delete motionMapMap[motion_id];
        };
        // End motion control /fnMotionEnd/
        //------------------ END MOTION CONTROLS -------------------

        //------------------- BEGIN EVENT HANDLERS -------------------
        // Begin event handler /onTouch/ for all touch events.
        // We use the 'type' attribute to dispatch to motion control
        onTouch = function ( event ) {
          var
            elem_this   = this,
            timestamp   = +new Date(),
            o_event     = event.originalEvent,
            a_touches   = o_event.changedTouches || [],
            idx, touch_event, motion_id,
            handler_fn
          ;

          doDisableMouse = true;

          event.timeStamp = timestamp;

          switch ( event.type ) {
            case 'touchstart' :
              handler_fn = fnMotionStart;
//             event.preventDefault();
              break;
            case 'touchmove'  :
              handler_fn = fnMotionMove;
//             event.preventDefault();
              break;
            case 'touchend'    :
            case 'touchcancel' : handler_fn = fnMotionEnd;   break;
            default : handler_fn = null;
          }

          if ( ! handler_fn ) { return; }

          for ( idx = 0; idx < a_touches.length; idx++ ) {
            touch_event  = a_touches[idx];

            motion_id = 'touch' + String(touch_event.identifier);

            event.clientX   = touch_event.clientX;
            event.clientY   = touch_event.clientY;
            handler_fn({
              elem      : elem_this,
              motion_id : motion_id,
              event_src : event
            });
          }
        };
        // End event handler /onTouch/


        // Begin event handler /onMouse/ for all mouse events
        // We use the 'type' attribute to dispatch to motion control
        onMouse = function ( event ) {
          var
            elem_this     = this,
            motion_id     = 'mouse' + String(event.button),
            request_dzoom = false,
            handler_fn
          ;

          if ( doDisableMouse ) {
            event.stopImmediatePropagation();
            return;
          }

          if ( event.shiftKey ) { request_dzoom  =  true; }

          // skip left or middle clicks
          if ( event.type !== 'mousemove' ) {
            if ( event.button !== 0 ) { return true; }
          }

          switch ( event.type ) {
            case 'mousedown' : handler_fn = fnMotionStart; break;
            case 'mouseup'   : handler_fn = fnMotionEnd;   break;
            case 'mousemove' :
              handler_fn = fnMotionMove;
//             event.preventDefault();
              break;
            default          : handler_fn = null;
          }

          if ( ! handler_fn ) { return; }

          handler_fn({
            elem          : elem_this,
            event_src     : event,
            request_dzoom : request_dzoom,
            motion_id     : motion_id
          });
        };
        // End event handler /onMouse/
        //-------------------- END EVENT HANDLERS --------------------


        // Export special events through jQuery API
        $Special.ue
          = $Special.utap       = $Special.uheld
          = $Special.uzoomstart = $Special.uzoommove = $Special.uzoomend
          = $Special.udragstart = $Special.udragmove = $Special.udragend
          = $Special.uheldstart = $Special.uheldmove = $Special.uheldend
          = Ue
        ;
        $.ueSetGlobalCb = function ( selector_str, callback_match, callback_nomatch ) {
          callbackList.push( {
            selector_str     : selector_str     || '',
            callback_match   : callback_match   || null,
            callback_nomatch : callback_nomatch || null
          });
        };
      },

      init_drags: function() {
        /* Jquery Udraggable
       * Modified by Anton
       * http://grantm.github.io/jquery-udraggable/
       */

        "use strict";

        var floor = Math.floor;
        var min = Math.min;
        var max = Math.max;

        window.requestAnimationFrame = window.requestAnimationFrame || function(work) {
          return setTimeout(work, 10);
        };

        window.cancelAnimationFrame = window.cancelAnimationFrame || function(id) {
          return clearTimeout(id);
        };


        // Constructor function

        var UDraggable = function(el, options) {
          var that = this;
          this.el = el;
          this.$el = $(el);
          this.options = $.extend({}, $.fn.udraggable.defaults, options);
          this.positionElement = this.options.positionElement || this.positionElement;
          this.getStartPosition = this.options.getStartPosition || this.getStartPosition;
          this.updatePositionFrameHandler = function() {
            delete that.queuedUpdate;
            if(that.ui) { // anton
              var pos = that.ui.position;
              that.positionElement(that.$el, that.started, pos.left, pos.top);
              if (that.options.dragUpdate) {
                that.options.dragUpdate.apply(that.el, [that.ui]);
              }
            }
          };
          this.queuePositionUpdate = function() {
            if (!that.queuedUpdate) {
              that.queuedUpdate = window.requestAnimationFrame(that.updatePositionFrameHandler);
            }
          };
          this.init();
        };

        UDraggable.prototype = {
          constructor: UDraggable,
          init: function() {
            var that = this;
            this.disabled = false;
            this.started = false;
            this.normalisePosition();
            var $target = this.options.handle ?
              this.$el.find(this.options.handle) :
              this.$el;

            $target
              .on('utapstart.udraggable', function(e) {
                $(document.body).addClass('draggable');
              })
              .on('utapend.udraggable', function(e) {
                $(document.body).removeClass('draggable');
              });

            if (this.options.longPress) {
              $target
                .on('uheldstart.udraggable', function(e) {
                  that.start(e);
                })
                .on('uheldmove.udraggable', function(e) {
                  that.move(e);
                })
                .on('uheldend.udraggable', function(e) {
                  that.end(e);
                });
            }
            else {
              $target
                .on('udragstart.udraggable', function(e) {
                  that.start(e);
                })
                .on('udragmove.udraggable', function(e) {
                  that.move(e);
                })
                .on('udragend.udraggable', function(e) {
                  that.end(e);
                });
            }
          },
          destroy: function() {
            var $target = this.options.handle ?
              this.$el.find(this.options.handle) :
              this.$el;
            $target.off('.udraggable');
            this.$el.removeData('udraggable');
          },
          disable: function() {
            this.disabled = true;
          },
          enable: function() {
            this.disabled = false;
          },
          option: function() {
            var name;
            if (arguments.length === 0) {
              return this.options;
            }
            if (arguments.length === 2) {
              this.options[ arguments[0] ] = arguments[1];
              return;
            }
            if (arguments.length === 1) {
              if (typeof arguments[0] === 'string') {
                return this.options[ arguments[0] ];
              }
              if (typeof arguments[0] === 'object') {
                for (name in arguments[0]) {
                  if (arguments[0].hasOwnProperty(name)) {
                    this.options[name] = arguments[0][name];
                  }
                }
              }
            }
            if (this.options.containment) {
              this._initContainment();
            }
          },
          normalisePosition: function() {
            var pos = this.$el.position();
            this.$el.css({
              position: this.options.position,
              top: pos.top,
              left: pos.left,
              right: 'auto',
              bottom: 'auto'
            });
          },
          start: function(e) {
            if (this.disabled) {
              return;
            }
            var start = this.getStartPosition(this.$el);
            this._initContainment();
            this.ui = {
              helper: this.$el,
              offset: {top: start.y, left: start.x},
              originalPosition: {top: start.y, left: start.x},
              position: {top: start.y, left: start.x}
            };
            if (this.options.longPress) {
              this._start(e);
            }
            return this._stopPropagation(e);
          },
          move: function(e) {
            if (this.disabled || (!this.started && !this._start(e))) {
              return;
            }
            var delta_x = e.px_current_x - e.px_start_x;
            var delta_y = e.px_current_y - e.px_start_y;
            var axis = this.options.axis;
            if (axis && axis === "x") {
              delta_y = 0;
            }
            if (axis && axis === "y") {
              delta_x = 0;
            }
            var cur = {
              left: this.ui.originalPosition.left,
              top: this.ui.originalPosition.top
            };
            if (!axis || (axis === "x")) {
              cur.left += delta_x;
            }
            if (!axis || (axis === "y")) {
              cur.top += delta_y;
            }
            this._applyGrid(cur);
            this._applyContainment(cur);
            var pos = this.ui.position;
            if ((cur.top !== pos.top) || (cur.left !== pos.left)) {
              this.ui.position.left = cur.left;
              this.ui.position.top = cur.top;
              this.ui.offset.left = cur.left;
              this.ui.offset.top = cur.top;
              if (this.options.drag) {
                this.options.drag.apply(this.el, [e, this.ui]);
              }
              this.queuePositionUpdate();
            }
            return this._stopPropagation(e);
          },
          end: function(e) {
            if (this.started || this._start(e)) {
              this.$el.removeClass("udraggable-dragging");
              this.started = false;
              if (this.queuedUpdate) {
                window.cancelAnimationFrame(this.queuedUpdate);
              }
              this.updatePositionFrameHandler();
              if (this.options.stop) {
                this.options.stop.apply(this.el, [e, this.ui]);
              }
            }
            return this._stopPropagation(e);
          },
          // helper methods

          _stopPropagation: function(e) {
            e.stopPropagation();
            e.preventDefault();
            return false;
          },
          _start: function(e) {
            if (!this._mouseDistanceMet(e) || !this._mouseDelayMet(e)) {
              return;
            }
            this.started = true;
            this.queuePositionUpdate();
            if (this.options.start) {
              this.options.start.apply(this.el, [e, this.ui]);
            }
            this.$el.addClass("udraggable-dragging");
            return true;
          },
          _mouseDistanceMet: function(e) {
            return max(
              Math.abs(e.px_start_x - e.px_current_x),
              Math.abs(e.px_start_y - e.px_current_y)
            ) >= this.options.distance;
          },
          _mouseDelayMet: function(e) {
            return e.ms_elapsed > this.options.delay;
          },
          _initContainment: function() {
            var o = this.options;
            var $c, ce;

            if (!o.containment) {
              this.containment = null;
              return;
            }

            if (o.containment.constructor === Array) {
              this.containment = o.containment;
              return;
            }

            if (o.containment === "parent") {
              o.containment = this.$el.offsetParent();
            }

            $c = $(o.containment);
            ce = $c[ 0 ];
            if (!ce) {
              return;
            }

            this.containment = [
              0,
              0,
              $c.innerWidth() - this.$el.outerWidth(),
              $c.innerHeight() - this.$el.outerHeight(),
            ];
          },
          _applyGrid: function(cur) {
            if (this.options.grid) {
              var gx = this.options.grid[0];
              var gy = this.options.grid[1];
              cur.left = floor((cur.left + gx / 2) / gx) * gx;
              cur.top = floor((cur.top + gy / 2) / gy) * gy;
            }
          },
          _applyContainment: function(cur) {
            var cont = this.containment;
            if (cont) {
              cur.left = min(max(cur.left, cont[0]), cont[2]);
              cur.top = min(max(cur.top, cont[1]), cont[3]);
            }
          },
          getStartPosition: function($el) {
            return {
              x: parseInt($el.css('left'), 10) || 0,
              y: parseInt($el.css('top'), 10) || 0
            };
          },
          positionElement: function($el, dragging, left, top) {
            $el.css({left: left, top: top});
          }

        };


        // jQuery plugin function

        $.fn.udraggable = function(option) {
          var args = Array.prototype.slice.call(arguments, 1);
          var results = [];

          this.each(function() {
            var $this = $(this);
            var data = $this.data('udraggable');
            if (!data) {
              data = new UDraggable(this, option);
              $this.data('udraggable', data);
            }
            if (typeof option === 'string') {  // option is a method - call it
              if (typeof data[option] !== 'function') {
                throw "jquery.udraggable has no '" + option + "' method";
              }
              var result = data[option].apply(data, args);
              if (result !== undefined) {
                results.push(result);
              }
            }
          });
          return results.length > 0 ? results[0] : this;
        };

        $.fn.udraggable.defaults = {
          axis: null,
          delay: 0,
          distance: 0,
          longPress: false,
          position: 'fixed',
          // callbacks
          drag: null,
          start: null,
          stop: function() {$(document.body).removeClass('draggable');}
        };
      },

      init_center_position: function() {
        $.fn.center = function(parent, scroll) {
          if (parent) {
            parent = this.parent();
          } else {
            parent = window;
          }

          var scroll_top = 0;
          var scroll_left = 0;

          if(scroll) {
            scroll_top = $(parent).scrollTop();
            scroll_left = $(parent).scrollLeft();
          }

          var top = (($(parent).height() - this.outerHeight()) / 2) + scroll_top;
          var left = (($(parent).width() - this.outerWidth()) / 2) + scroll_left;

          top = top < 0 ? 0 : top;
          left = left < 0 ? 0 : left;

          this.css({
            top: top + 'px',
            left: left + 'px'
          });

          return this;
        };
      },

      place_close_btn: function() {
        if(typeof config.escape === 'function') {
          $('<a id="jipt-close-btn">').html('&times;').attr('href', '#').appendTo('#jipt-modal-mask').click(function(e) {
            e.preventDefault();
            config.escape();
          });
        }
      },

      init_access_storage_dialog: function() {
        jipt.editorAccessStorageDialog = $('<div id="crowdin-access-storage-editor">');

        jipt.editorAccessStorageDialog.jiptDialog({
          width: '380px',
          height: '175px',
          drags: false,
          minimize_btn: false,
          close_btn: false,
          save_position: false,
          modal: false,
          icon: 'crowdin',
          title_pane: '<h4>Allow Access to Storage Access API</h4>',
        });

        jipt.editorAccessStorageDialog.append('<iframe frameBorder="0" id="crowdin-access-storage-editor-iframe"></iframe>');

        jipt.editorAccessStorageDialogIframe = $('iframe#crowdin-access-storage-editor-iframe');
        jipt.editorAccessStorageDialogIframe.css({
          'width': '100%',
          'display': 'block',
          'overflow': 'hidden',
          'height': '175px',
        });

        jipt.editorAccessStorageDialogIframe.attr('src', Url.getEntryPoint() + '/editor?jipt_access_storage=true&jipt=' + document.location.origin);
      },

      init_login_panel: function() {
        jipt.loginDialog = $('<div>').
        attr('id', 'jipt-login-panel').
        html(jipt.loginDialogContent());

        jipt.loginDialog.content = jipt.loginDialog.jiptDialog({
          modal: true,
          width: '360px',
          height: '400px',
          drags: true,
          minimize_btn: false,
          close_btn: false,
          iframe: true,
          custom_class: 'jipt-login-dialog',
          title_pane: getLoginDialogTitle()
        });

        function getLoginDialogTitle() {
          return '<div>' +
            '<div style="min-height: 24">' +
            '<svg class="crowdin-jipt-logo" width="116" height="24">' +
            '<image xlink:href="' + Url.jiptCDN + '/images/crowdin-logo-small.svg" src="' + Url.jiptCDN + '/images/crowdin-logo-small.png" width="116" height="24" alt="Crowdin &mdash Localization Management Platform" />' +
            '</svg>' +
            '</div>' +
            '<h3 class="crowdin-jipt-login-header">Crowdin In-Context Translations</h3>' +
            '</div>';
        }

        jipt.loginDialog.content.find('#crowdin-login-language-field').change(function() {
          jipt.loginDialog.content.find('#crowdin-login-workflow-step-field').html(
            jipt.getWorkflowStepsOptions($(this).val())
          );
        });

        jipt.loginDialog.content.find('#crowdin-language-field').change(function() {
          jipt.loginDialog.content.find('#crowdin-workflow-step-field').html(
            jipt.getWorkflowStepsOptions($(this).val())
          );
        });

        jipt.loginDialog.content.find('#crowdin-jipt-login').click(function() {
          jipt._login_action();
          return false;
        });

        jipt.loginDialog.content.find('#crowdin-join').click(function() {
          jipt._join_action();
          return false;
        });

        jipt.loginDialog.content.find('#crowdin-select-language-and-step').click(function() {
          var language = jipt.loginDialog.content.find('#crowdin-language-field option:selected');
          jipt.set_current_language(language.val(), language.data('id'), language.html());

          var workflow_step = jipt.loginDialog.content.find('#crowdin-workflow-step-field option:selected');
          jipt.setCurrentWorkflowStep(workflow_step.val(), workflow_step.html());

          jipt.loginDialog.jiptDialog({action: 'close'});

          jipt.init_project();
          return false;
        });

        jipt.loginDialog.content.find('.crowdin-jipt-to-login').click(function() {
          jipt.show_login_panel();
        });
      },

      init_highlight: function() {
        if(Storage.get('highlight') !== 'no') {
          jipt.translations_highlight = true;
          $('body').addClass('jipt-highlight');
        } else {
          jipt.translations_highlight = false;
          $('body').removeClass('jipt-highlight');
        }
      },

      init_preview: function() {
        if(Storage.get('preview') !== 'no') {
          jipt.translations_preview = true;
        } else {
          jipt.translations_preview = false;
        }
      },

      init_filter: function() {
        if(config.preload_texts && Storage.get('filter') !== 'yes') {
          jipt.translations_filter = false;
        } else {
          jipt.translations_filter = true;
        }
      },

      init_touch_optimized: function() {
        if(config.touch_optimized && Storage.get('touch_optimized') !== 'no') {
          $('#crowdin-translation-badge').remove();
          jipt.touch_optimized = true;
        } else {
          jipt.touch_optimized = false;
        }
      },

      init_translation_panel: function() {
        var timeout = null;

        jipt.translationDialog = $('<div>').
        attr('id', 'crowdin-translation-panel').
        html(jipt.translationDialogContent());

        jipt.translationDialog.content = jipt.translationDialog.jiptDialog({
          width: '400px',
          height: '400px',
          drags: true,
          save_position: true,
          save_height: true,
          close_btn: false,
          iframe: true,
          position: 'bottom-left',
          custom_class: 'jipt-translations-dialog',
          icon: 'crowdin',
          minimized: jipt.minimized_translation_panel,
          title_pane: getTranslationDialogTitle(),
          buttons_pane: getTranslationDialogButtons()
        });

        function getTranslationDialogTitle() {
          var screenshotBtn = '<li class="hide"><a id="jipt-screenshot_minimized" title="Take Screenshot" href="#jipt-screenshot" class="jipt-btn jipt-btn-icon"><i class="jipt-icon-add-screenshot"></i></a></li>';
          var previewIsActive = jipt.translations_preview === true ? 'active' : '';
          var highlightIsActive = jipt.translations_highlight === true ? 'active' : '';

          return '' +
            '<h4 class="jipt-dialog-title-name">Crowdin In-Context</h4>' +
            '<div class="jipt-dialog-buttons-wrapper">' +
              '<ul id="translation_panel_tabs_minimized" class="jipt-tabs jipt-tabs--main">' +
                '<li>' +
                    '<a id="show_translations_minimized" title="Source Strings" class="jipt-btn active jipt-btn-icon" href="#jipt-translations">' +
                        '<i class="jipt-icon-home"></i>' +
                    '</a>' +
                '</li>' +
                screenshotBtn +
                '<li class="hide"><a id="show_options_minimized" href="#jipt-options" title="Settings" class="jipt-btn jipt-btn-icon"><i class="jipt-icon-options"></i></a></li>' +
              '</ul>' +
              '<ul class="jipt-shortuctuts jipt-tabs">' +
                  '<li>' +
                      '<a id="jipt-shortctut-preview-toggle" href="javascript:void(0)" title="Toggle Preview Translations" class="jipt-btn jipt-btn-icon ' + previewIsActive + '"><i class="jipt-icon-preview"></i></a>' +
                  '</li>' +
                  '<li>' +
                      '<a id="jipt-shortctut-highlight-toggle" href="javascript:void(0)" title="Toggle Highlight" class="jipt-btn jipt-btn-icon ' + highlightIsActive + '"><i class="jipt-icon-highlight"></i></a>' +
                  '</li>' +
              '</ul>' +
            '</div>';
        }

        function getTranslationDialogButtons() {
          return jipt.translationDialogButtons();
        }

        jipt.translationDialog.jiptDialog({action: 'open'});

        var targetLanguages = jipt.translationDialog.content.find('#jipt-target-languages')
        targetLanguages.html(jipt._get_target_languages_options());

        jipt.translationDialog.content.find('#jipt-workflow-step').html(
          jipt.getWorkflowStepsOptions($(targetLanguages).val())
        );

        jipt.load_phrases();

        jipt.translationDialog.content.find('#jipt-target-languages').change(function() {
          jipt.translationDialog.content.find('#jipt-workflow-step').html(
            jipt.getWorkflowStepsOptions($(this).val())
          );
        });

        jipt.translationDialog.content.find('#jipt-change-language-and-step').click(function() {
          var selected = jipt.translationDialog.content.find('#jipt-target-languages').find('option:selected');
          jipt.set_current_language(selected.val(), selected.data('id'), selected.html());

          var workflow_step = jipt.translationDialog.content.find('#jipt-workflow-step').find('option:selected');
          jipt.setCurrentWorkflowStep(workflow_step.val(), workflow_step.html());

          window.location.reload();
        });

        jipt.translationDialog.content.find('#jipt-logout').click(function() {
          jipt._logout_action();
          return false;
        });

        jipt.translationDialog.content.find('#jipt-translations-preview').change(function() {
          if ($(this).prop('checked')) {
            Storage.save('preview', 'yes');
          } else {
            Storage.save('preview', 'no');
          }
          jipt.init_preview();
          jipt.set_translations_preview();
          $('#jipt-shortctut-preview-toggle')[jipt.translations_preview ? 'addClass' : 'removeClass']('active');
        });

        jipt.translationDialog.content.find('#jipt-translations-highlight').change(function() {
          if ($(this).prop('checked')) {
            Storage.save('highlight', 'yes');
          } else {
            Storage.save('highlight', 'no');
          }
          jipt.init_highlight();
          $('#jipt-shortctut-highlight-toggle')[jipt.translations_highlight ? 'addClass' : 'removeClass']('active');
        });

        jipt.translationDialog.content.find('#jipt-translations-filter').change(function() {
          if ($(this).prop('checked')) {
            Storage.save('filter', 'yes');
          } else {
            Storage.save('filter', 'no');
          }
          jipt.init_filter();
          jipt.rebuild_panel_phrases(jipt.panel_search_phrase);
        });

        jipt.translationDialog.content.find('#jipt-touch-optimized').change(function() {
          if ($(this).prop('checked')) {
            Storage.save('touch_optimized', 'yes');
          } else {
            Storage.save('touch_optimized', 'no');
          }
          jipt.init_touch_optimized();
          jipt.set_translations_preview();
        });

        jipt.translationDialog.content.on('click', '.jipt-phrases-to-translate li:not(.disabled) a', function() {
          jipt.show_editor(jipt.phrases[this.rel].data);
          return false;
        });

        jipt.translationDialog.content.on('click', '#jipt-hotkeys-settings', function() {
          jipt.show_settings('hotkeys');
          return false;
        });

        jipt.translationDialog.content.on('click', '#jipt-editor-settings', function() {
          jipt.show_settings('editor');
          return false;
        });

        $('#translation_panel_tabs a').click(function(e) {
          if(!$(this).hasClass('active')) {
            var hrefHash = $(this).attr('href').substring($(this).attr('href').indexOf('#'));

            if(hrefHash === '#jipt-screenshot' && jipt.user.isManager) {
              maskElement(jipt.translationDialog.content.find('#jipt-screenshot'));
              jipt.translationDialog.content.find('#jipt-search-screenshots').val(jipt.get_screenshot_name());
              jipt.get_screenshots(jipt.get_screenshot_name());
            }

            $(this).closest('ul').find('a').removeClass('active');
            $(this).addClass('active');

            var translationPanelTabElementId = $(this).attr('id') + '_minimized';
            $('#translation_panel_tabs_minimized a').removeClass('active');
            $('#translation_panel_tabs_minimized').find('#' + translationPanelTabElementId).addClass('active');

            jipt.translationDialog.content.find('#translation_panel_tabs_content .jipt-tab-pane').hide();

            jipt.translationDialog.content.find(hrefHash).show();
          }
          return false;
        });

        $('#translation_panel_tabs_minimized a').click(function(e) {
          if(!$(this).hasClass('active')) {
            $(this).closest('ul').find('a').removeClass('active');
            $(this).addClass('active');

            var translationPanelTabElementId = $(this).attr('id').replace('_minimized', '');
            $('#translation_panel_tabs a').removeClass('active');
            $('#translation_panel_tabs').find('#' + translationPanelTabElementId).addClass('active');

            jipt.translationDialog.content.find('#translation_panel_tabs_content .jipt-tab-pane').hide();

            var hrefHash = $(this).attr('href').substring($(this).attr('href').indexOf('#'));
            jipt.translationDialog.content.find(hrefHash).show();
          }
          return false;
        });

        $('#show_translations, #show_translations_minimized').click(function() {
          if (jipt.panel_pages) {
            $('#translation_panel_paging_wrapper').show();
          }
          jipt.translationDialog.parent().removeClass('jipt_options');
        });

        $('#show_options, #show_options_minimized').click(function() {
          $('#translation_panel_paging_wrapper').hide();
          jipt.translationDialog.parent().addClass('jipt_options');
        });

        $('#jipt-screenshot, #jipt-screenshot_minimized').click(function() {
          $('#translation_panel_paging_wrapper').hide();
        });

        $('#jipt-shortctut-preview-toggle').click(function(e) {
          Storage.save('preview', jipt.translations_preview ? 'no' : 'yes');

          jipt.init_preview();
          jipt.set_translations_preview();

          jipt.translationDialog.content.find('#jipt-translations-preview').prop('checked', jipt.translations_preview);
          $(this).toggleClass('active');
        });


        $('#jipt-shortctut-highlight-toggle').click(function(e) {
          Storage.save('highlight', jipt.translations_highlight ? 'no' : 'yes');

          jipt.init_highlight();

          jipt.translationDialog.content.find('#jipt-translations-highlight').prop('checked', jipt.translations_highlight);
          $(this).toggleClass('active');
        });

        jipt.translationDialog.content.find('#make_screenshot').click(function() {
          if(!jipt.user.isManager) {
            return;
          }

          var storageScreenshotName = jipt.translationDialog.content.find('#jipt-search-screenshots').val();

          if(storageScreenshotName.trim() === '') {
            jipt.translationDialog.content.find('#screenshot-status')
              .addClass('alert-error')
              .text('Please write a screenshot name to proceed.')
              .show();

            return;
          }

          var takeScreenshotBtn = this;

          //disable btn and hide highlights and preview before generating screenshot
          $(takeScreenshotBtn).attr('disabled', true);

          jipt.make_screenshot(
            storageScreenshotName,
            jipt.handle_make_screenshot_error,
            jipt.handle_make_screenshot_data,
            true
          );
        });

        jipt.translationDialog.content.find('#jipt-search-screenshots').on('input propertychange', function() {
          var self = this

          clearTimeout(timeout);

          timeout = setTimeout(function() {
            jipt.get_screenshots(self.value);
          }, 500);
        });

        jipt.translationDialog.content.find('.jipt-search-phrase').on('input propertychange', function() {
          clearTimeout(timeout);
          jipt.panel_search_phrase = this.value;

          var clear_btn = $(this).parent().find('.jipt-clear-btn');

          if(jipt.panel_search_phrase) {
            clear_btn.show();
          } else {
            clear_btn.hide();
          }

          timeout = setTimeout(function() {
            jipt.rebuild_panel_phrases(jipt.panel_search_phrase);
          }, 300);
        });

        $('#translation_panel_prev_page').click(function() {
          if(jipt.panel_page > 0) {
            jipt.rebuild_panel_phrases(jipt.panel_search_phrase, jipt.panel_page - 1);
          }
          return false;
        });

        $('#translation_panel_next_page').click(function() {
          if(jipt.panel_page + 1 < jipt.panel_pages) {
            jipt.rebuild_panel_phrases(jipt.panel_search_phrase, jipt.panel_page + 1);
          }
          return false;
        });

        jipt.translationDialog.content.find('.jipt-clear-btn').click(function() {
          var input = $(this).siblings('input[type="text"]').val('');
          jipt.panel_search_phrase = '';
          jipt.rebuild_panel_phrases();
          $(this).hide();
          input.focus();
          return false;
        });

        $('#translation_panel_current_page').click(function() {
          $(this).val(jipt.panel_page + 1);
          $(this).select();
          return false;
        });

        $('#translation_panel_paging').submit(function() {
          var page = $('#translation_panel_current_page').val();
          jipt.rebuild_panel_phrases(jipt.panel_search_phrase, page - 1);
          $('#translation_panel_current_page').blur();
          return false;
        });
      },

      get_screenshot_name: function() {
        var storageScreenshotName = document.title;
        if (!document.title) {
          storageScreenshotName = window.location.hostname + window.location.pathname;
        }

        return storageScreenshotName.replace(/\\|\/|:|\*|\?|"|<|>|\|/ig, '.');
      },

      get_screenshots: function(searchText) {
        if(!searchText) {
          jipt.handle_get_screenshots_data({
            response: {data: []},
            search_data: {search: ''}}
          );
          return;
        }

        var message = {
          msg_type: 'get_screenshots',
          url: Url.getFullUrl(`/api/v2/projects/${jipt.projectModelId}/screenshots`),
          data: {
            orderBy: 'updatedAt desc',
            search: searchText
          },
        };

        jipt.send_post_message(message);
      },

      handle_get_screenshots_data: function(message) {
        var response = message.response;
        var searchData = message.search_data
        var screenshots = response.data.filter(i => i.data.name.startsWith(searchData.search));
        var screenshotsList = jipt.translationDialog.content.find('#jipt-screenshots');
        var screenshotsListLabel = jipt.translationDialog.content.find('.jipt-screenshots-label');
        var screenshotsButton = jipt.translationDialog.content.find('#make_screenshot');

        screenshotsList.html('');
        let screenshotsListHtml =  '';

        if (screenshots.length) {
          screenshotsButton.text('Replace Screenshot');

          screenshots.forEach(function(screenshot) {
            const updatedAt = new Intl.DateTimeFormat('en-US', {
              year: 'numeric',
              month: 'short',
              day: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
              hour12: false,
              timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            }).format(new Date(screenshot.data.updatedAt));

            screenshotsListHtml += `<option value="${screenshot.data.id}">${screenshot.data.name} (${updatedAt})</option>`;
          });
        } else {
          screenshotsButton.text('Add Screenshot');

          screenshotsListHtml = `<option value="0">There is no screenshot with this name</option>`;
        }

        screenshotsList.html(screenshotsListHtml);

        screenshotsList.attr('disabled', !screenshots.length);
        screenshotsListLabel.toggleClass('jipt-muted', !screenshots.length);
        screenshotsButton.attr('disabled', !searchData.search.length).toggleClass('disabled', !searchData.search.length);

        unmaskElement(jipt.translationDialog.content.find('#jipt-screenshot'));
      },

      handle_make_screenshot_error: function(error) {
        if(!jipt.translationDialog) {
          return;
        }

        jipt.translationDialog.content.find('#screenshot-status')
          .removeClass('alert-gray')
          .addClass('alert-error')
          .text('Something went wrong. Please, try again or contact support');

        jipt.translationDialog.content.find('#make_screenshot').attr('disabled', false);
      },

      handle_init_access_storage: function(message) {
        if (message.has_access) {
          jipt.editorAccessStorageDialog.jiptDialog({action: 'close'});

          jipt.init_login_panel();
          jipt.init_highlight();
          jipt.init_preview();
          jipt.init_filter();
          jipt.init_touch_optimized();
          jipt.init_project();
        } else {
          jipt.editorAccessStorageDialog.jiptDialog({action: 'open'});
        }
      },

      init_project: function() {
        var project = get_project_identifier();
        var language_code = Storage.get('language_code');

        var workflowStepId = +Storage.get('workflow_step_id') || undefined;

        var message = {
          msg_type: 'init_project',
          url: Url.getFullUrl('/api/v2/jipt/project/' + project),
          data: {
            origin: document.location.protocol + '//' + document.location.host,
            pathName: document.location.pathname + document.location.search,
            languageCode: language_code ? language_code : '',
            workflowStepId: workflowStepId,
            preloadTexts: config.preload_texts
          }
        };

        jipt.send_post_message(message);
      },

      handle_init_project_data: function (message) {
        const response = message.response;

        var language_id = Storage.get('language_id');
        var language_code = Storage.get('language_code');
        var language_name = Storage.get('language_name');

        var workflowStepId = +Storage.get('workflow_step_id') || undefined;

        // XXX(joshuan): assign id/name based on code
        // The correct language_id and language_name can be
        // determined based on language_code, but normally they
        // are assigned separately for some reason. This change
        // makes mismatches between code, id, and name less likely.
        // As a nice sideeffect, it also eliminates the language
        // selection dialog when a user is already logged in.
        for (var i = 0; i < response.data.targetLanguages.length; ++i) {
            var lang = response.data.targetLanguages[i];
            if (lang.code === language_code) {
                Storage.save("language_id", lang.id);
                language_id = lang.id;
                Storage.save("language_name", lang.name);
                language_name = lang.name;
            }
        }
        config.preload_texts = JSON.parse(response.data.preloadTexts); // convert to boolean ("false" -> false)

        jipt.user.isLoggedIn = response.data.isLoggedIn;
        jipt.user.isLeader = response.data.isLeader;
        jipt.user.isManager = response.data.isManager;
        jipt.user.login = response.data.login;
        jipt.user.name = response.data.userName;
        jipt.user.picture = response.data.userPicture;
        jipt.user.workflowStepId = response.data.workflowStepId;
        jipt.user.redirectHash = response.data.redirectHash;
        jipt.workflowStepIds = response.data.workflowStepIds;
        jipt.source_language.code = response.data.sourceLanguageCode;
        jipt.target_languages = response.data.targetLanguages;
        jipt.workflowSteps = response.data.workflowSteps || [];
        jipt.projectLink = response.data.editorLink;
        jipt.projectId = response.data.projectId;
        jipt.projectModelId = response.data.projectModelId;
        jipt.projectName = response.data.projectName;
        jipt.projectURL = response.data.projectUrl;
        // XXX(michaelpolyak): `pluralsPreview` is always returned as `false`
        // in the API response. It cannot be enabled in the project settings.
        // jipt.pluralsPreview = response.data.pluralsPreview;
        jipt.hasIcu = response.data.hasIcu;

        for (var fileFormat of Object.keys(response.data.placeholdersRegexps)) {
          jipt.regexp.placeholders[fileFormat] = new RegExp(response.data.placeholdersRegexps[fileFormat], 'gi');
        }

        if(!response.data.isLoggedIn) {
          jipt.show_login_panel();
          return;
        }
        if(!language_code || !language_name || !language_id || response.data.missedLanguage) {
          jipt.show_languages_panel();
          return;
        }

        jipt.language.code = language_code;
        jipt.language.id = language_id;
        jipt.language.name = language_name;

        jipt.workflowStep.id = workflowStepId;

        jipt.init_editor();

        jipt.isStarting = false;
      },

      init_translations: function() {
        jipt.alertFunction = window.alert;
        window.alert = function() {
          return jipt.handle_browser_popups(jipt.alertFunction, this, arguments);
        };

        jipt.confirmFunction = window.confirm;
        window.confirm = function() {
          return jipt.handle_browser_popups(jipt.confirmFunction, this, arguments);
        };

        jipt.promptFunction = window.prompt;
        window.prompt = function() {
          return jipt.handle_browser_popups(jipt.promptFunction, this, arguments);
        };

        if(jipt.hasIcu) {
          jipt.init_icu();
        }

        jipt.init_translation_panel();
      },

      handle_browser_popups: function(method, context, args) {
        var translations = [];

        for(var i = 0; i < args.length; i++) {
          args[i] = args[i].replace(jipt.regexp.globalPhrase, function(match, phrase_id, plural_id) {
            var phrase = jipt.phrases[phrase_id].data;

            if(phrase) {
              translations.push(phrase);
              var source_segment = jipt.get_source_segment(phrase, plural_id);
              var new_value = jipt.phrase2preview(
                phrase,
                phrase.isIcu
                  ? jipt.get_icu_placeholders(source_segment, match)
                  : jipt.get_placeholders(source_segment, match, phrase.fileFormat),
                plural_id
              );

              if(config.edit_strings_context) {
                jipt.update_strings_context(phrase.id, phrase.context);
              }

              new_value = config.before_dom_insert(new_value);
              if(new_value === false) {
                return match;
              }

              return new_value;
            } else {
              jipt._load_phrases_delayed(match, function() {});
              return match;
            }
          });
        }

        var result = method.apply(context, args);

        if(translations.length > 0) {
          jipt.show_editor(translations[0]);
        }

        return result;
      },

      init_dom_mutation_handler: function() {
        var MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;

        if(MutationObserver) {
          jipt.mutationObserver = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
              jipt.handle_dom_mutation(mutation);
            });
          });

          jipt.mutationObserver.observe(document.body, {attributes: true, childList: true, characterData: true, subtree: true, characterDataOldValue: true, attributeOldValue: true});
        }
      },

      handle_dom_mutation: function(mutation) {
        if(mutation.type === 'childList') {
          for(var i = 0; i < mutation.addedNodes.length; i++) {
            jipt.crowdin_each_element(mutation.addedNodes[i]);
          }

          if(mutation.removedNodes.length && jipt.translations_filter) {
            jipt.remove_phrases_not_on_page();
          }
        }

        if(mutation.type === 'characterData') {
          if(mutation.target.nodeType === 3) {
            jipt.match_element_text(mutation.target, mutation.target.parentNode);
          }
        }

        if(jipt.check_if_jipt_class_was_removed(mutation)) {
          var matches = mutation.oldValue.match(/crowdin_jipt_[^\s-]+/);
          if(matches[0]) {
            $(mutation.target).addClass(matches[0]);
          }
        }

        if(mutation.type === 'attributes') {
          jipt.match_element_attributes(mutation.target);
        }
      },

      check_if_jipt_class_was_removed: function(mutation) {
        return (
          mutation.type === 'attributes'
          && mutation.attributeName === 'class'
          && typeof mutation.target.className.indexOf === 'function'
          && mutation.target.className.indexOf('crowdin_jipt_') === -1
          && mutation.oldValue
          && mutation.oldValue.indexOf('crowdin_jipt_') !== -1
        );
      },

      remove_phrases_not_on_page: function() {
        for(var i in jipt.phrases) {
          var p = jipt.phrases[i].data;

          if(p.elements) {
            for(var el = 0; el < p.elements.length; el++) {
              if(!$(document.body).find(p.elements[el].element).length) {
                p.elements.splice(el, 1);

                if(!p.elements.length) {
                  delete p.elements;
                  break;
                }
              }
            }
          }
        }

        jipt.delayed_rebuild_panel_phrases();
      },

      findTextsDOM: function() {
        for(var name in self.status) {
          $('.crowdin_jipt_' + this.status[name]).removeClass('crowdin_jipt_' + this.status[name]);
        }

        var phrases_ids = jipt.get_phrases_from_text(document.documentElement.innerHTML);

        // if no old placeholders found - search for new placeholders
        if($.isEmptyObject(phrases_ids)) {
          $.extend(jipt.regexp, jipt.regexp_new);
          phrases_ids = jipt.get_phrases_from_text(document.documentElement.innerHTML);
        }

        return phrases_ids;
      },

      load_phrases: function() {
        var phrases_ids = this.findTextsDOM();
        var self = this;

        if ($.isEmptyObject(phrases_ids)) {
          setTimeout(function(){
            var _phrases_ids = self.findTextsDOM();

            if(jipt.user.isManager && $.isEmptyObject(_phrases_ids) && Storage.get('no_phrases_warning_disabled') !== 'yes') {
              self._show_no_texts_warning();
            }
          }, 5000);
        }

        jipt._load_phrases(phrases_ids, [() => {
          if(document.getElementsByTagName('title').length) {
            jipt.handle_document_title(document.getElementsByTagName('title')[0]);
          }

          jipt.crowdin_each_element(document.body);
          jipt.init_dom_mutation_handler();

          unmaskDocument();
        }]);
      },

      init_editor: function() {
        var editor_height = 650;
        var client_height = document.documentElement.clientHeight;

        editor_height = editor_height + 110 > client_height ? client_height - 110 : editor_height;

        jipt.editorDialog = $('<div id="crowdin-editor">');

        jipt.editorDialog.jiptDialog({
          width: '550px',
          parent_height: editor_height + 'px',
          height: 'calc(100% - 46px)',
          save_position: true,
          modal: false,
          drags: true,
          resize: true,
          icon: 'crowdin',
          custom_class: 'jipt-editor-dialog',
          minimize_btn: false,
          resize_btn: true,
          close_callback: function() {EditorDialogClose();},
          title_pane: getEditorDialogTitle(),
        });

        function getEditorDialogTitle() {
          return '<h4>Translating to ' + jipt.language.name + '</h4>';
        }

        jipt.editorDialog.append('<iframe frameBorder="0" id="crowdin-editor-iframe"></iframe>');

        jipt.editorDialogIframe = $('iframe#crowdin-editor-iframe');
        jipt.editorDialogIframe.css({
          'width': '100%',
          'display': 'block',
          'overflow': 'hidden',
          'height': `100%`,
        });

        jipt.editorDialogIframe.attr('src', jipt.projectLink);

        function EditorDialogClose() {
          jipt.place_translation_preview();
          $('.jipt-selected').removeClass('jipt-selected');
        }
      },

      send_post_message: function(message) {
        message = JSON.stringify(message);

        const editorIframe = jipt.editorDialogIframe || jipt.editorAccessStorageDialogIframe;

        if(editorIframe.length) {
          editorIframe.get(0).contentWindow.postMessage(message, Url.getEntryPoint());
        }
      },

      init_editor_listener: function() {
        window.onmessage = function(event) {
          event = event || window.event;

          if(event.origin !== Url.getEntryPoint()) {
            return;
          }

          var message = typeof event.data === 'object'
            ? event.data
            : JSON.parse(event.data);

          switch(message.msg_type) {
            case 'request_jipt_error':
              if (typeof message.response === 'string' || message.response instanceof String) {
                jipt._show_error_dialog(message.response, message.hide_logout_link);
              } else {
                jipt._handle_jipt_error(message.response);
              }
              break;
            case 'init_access_storage':
              jipt.handle_init_access_storage(message);
              break;
            case 'init_project_data':
              jipt.handle_init_project_data(message);
              break;
            case 'load_phrases_data':
              jipt.handle_load_phrases_data(message);
              break;
            case 'get_screenshots_data':
              jipt.handle_get_screenshots_data(message);
              break;
            case 'make_screenshot_data':
              jipt.callbacks.make_screenshot_success && jipt.callbacks.make_screenshot_success(message);
              break;
            case 'make_screenshot_error':
              jipt.callbacks.make_screenshot_error && jipt.callbacks.make_screenshot_error(message);
              break;
            case 'edit_translation':
              if(jipt.editor.currentTranslation) {
                if(jipt.translations_preview !== false && jipt.editorDialog.jiptDialog({action: 'is_visible'})) {
                  if(message.value.length > 0) {
                    jipt.place_translation_preview(+message.translation_id, message.value, message.plural_id);
                  } else {
                    jipt.place_translation_preview();
                  }
                }
              }
              break;

            case 'update_phrase':
            case 'update_translation':
              var currentTranslation = jipt.editor.currentTranslation;
              jipt.editor.currentTranslation = jipt.phrases[message.translation_id].data;

              if('top_suggestion' in message) {
                var plural_id = message.plural_id >= 0 ? message.plural_id : 0;

                jipt.editor.currentTranslation.translation[plural_id] = message.top_suggestion;

                // XXX(joshuan): Only update the status if we're not translated, or the suggestion
                // passes lint.
                // NOTE: The strange indentation is to avoid modifying the original lines.
                if(!message.translation_status.translated || !config.ka_on_save || config.ka_on_save(jipt.editor.currentTranslation)) {
                  jipt.editor.currentTranslation.status = message.translation_status;

                  jipt.place_translation_preview();
                }
              } else {
                // update translation
                jipt.editor.currentTranslation.hidden = message.translation.hidden;
              }

              jipt.update_phrase_dom_highlight();
              jipt.update_phrase_highlight();

              jipt.editor.currentTranslation = currentTranslation;
              break;

            case 'next_translation':
              if(jipt.editor.currentTranslation) {
                jipt.place_translation_preview();
                jipt.show_next_element(jipt.editor.currentTranslation.active_element);
              }
              break;

            case 'prev_translation':
              if(jipt.editor.currentTranslation) {
                jipt.place_translation_preview();
                jipt.show_prev_element(jipt.editor.currentTranslation.active_element);
              }
              break;

            case 'success':
              jipt.init_translations();

              jipt.editor_loaded = true;
              jipt.setup_jipt_validation();

              if(jipt.editor.currentTranslation) {
                jipt.show_editor(jipt.editor.currentTranslation, jipt.editor.currentTranslation.active_element);
              }

              break;

            case 'close_editor':
              jipt.editorDialog.jiptDialog({action: 'close'});
              break;

            case 'focus':
              jipt.editorDialog.jiptDialog({action: 'move_to_front'});
              break;

            case 'before_commit':
              jipt.handle_before_commit_request(message.request_id, message.data);
              break;

            case 'save_suggestions':
              jipt.handle_save_suggestions(message.data);
              break;

            case 'editor_settings':
              jipt.editor_settings();
              break;

            case 'close_editor_settings':
              jipt.open_editor_settings = false;
              jipt.close_editor_dialog();
              break;

            case 'hotkeys_settings':
              jipt.hotkeys_settings();
              break;

            case 'close_hotkeys_settings':
              jipt.open_hotkeys_settings = false;
              jipt.close_editor_dialog();
              break;

            case 'logged_out':
              window.location.reload();
              break;

            default:
              return;
          }
        };
      },

      destroy: function() {
        jipt.destroy_dialogs();
        jipt.destroy_dom_mutation_handler();

        jipt.destroy_crowdin_each_element(document.body);
      },

      destroy_dialogs: function() {
        jipt.destroy_dialog(jipt.loginDialog);
        jipt.loginDialog = null;

        jipt.destroy_dialog(jipt.editorDialog);
        jipt.editorDialog = null;
        jipt.editorDialogIframe = null;

        jipt.destroy_dialog(jipt.editorAccessStorageDialog);
        jipt.editorAccessStorageDialog = null;
        jipt.editorAccessStorageDialogIframe = null;

        jipt.destroy_dialog(jipt.translationDialog);
        jipt.translationDialog = null;
      },

      destroy_dialog: function(dialog) {
        dialog && dialog.jiptDialog({action: 'destroy'});
      },

      destroy_dom_mutation_handler: function() {
        if(jipt.mutationObserver) {
          jipt.mutationObserver.disconnect();
          jipt.dom_mutation_observer = null;
        }
      },

      destroy_crowdin_each_element: function(element) {
        if (element.id === 'crowdin-translation-panel' || element.id === 'crowdin-editor') {
          return;
        }

        // Recursively process child nodes
        if (element.hasChildNodes()) {
          for (let i = element.childNodes.length - 1; i >= 0; i--) {
            this.destroy_crowdin_each_element(element.childNodes[i]);
          }
        }

        const $element = $(element);

        // Remove Crowdin-specific classes
        $element.removeClass((index, className) => {
          if (typeof className !== 'string') {
            return '';
          }

          const classesToRemove = className.match(/(^|\s)crowdin_jipt_\S+/g) || [];

          if (classesToRemove.length) {
            // Remove event listeners
            $element.off('mouseenter');

            // Remove data attributes
            $element.removeData('phrases');
          }

          return classesToRemove.join(' ');
        });

        // Remove translation badges
        jipt.hide_translation_badge($element);
      },

      close_editor_dialog: function() {
        $('.jipt-dialog-title h4', '.jipt-editor-dialog').text('Translating to ' + jipt.language.name);

        if(!jipt.editor.currentTranslation && !jipt.open_editor_settings && !jipt.open_hotkeys_settings) {
          jipt.editorDialog.jiptDialog({action: 'close'});
        }
      },

      setup_jipt_validation: function() {
        var message = {
          msg_type: 'setup_jipt_validation',
          validation_enabled: config.before_commit !== null
        };

        jipt.send_post_message(message);
      },

      handle_before_commit_request: function(request_id, data) {
        var result = config.before_commit(data.source, data.translation, data.context, data.language);

        var message = {
          msg_type: 'before_commit_result',
          request_id: request_id,
          result: result
        };

        jipt.send_post_message(message);
      },

      handle_save_suggestions: function(data) {
        if(!this.callbacks.save_suggestions) {
          return false;
        }

        if(typeof(this.callbacks.save_suggestions) == 'function') {
          this.callbacks.save_suggestions(data);
        }
      },

      set_draft_suggestion: function(translation_id, text) {
        var message = {
          msg_type: "set_draft_suggestion",
          translation_id: translation_id,
          text: text
        };

        jipt.send_post_message(message);
      },

      save_suggestions: function(suggestions, force_saving, callback) {
        this.callbacks.save_suggestions = callback;

        var message = {
          msg_type: "save_suggestions",
          suggestions: suggestions,
          force_saving: force_saving
        };

        jipt.send_post_message(message);
      },

      editor_settings: function() {
        jipt.open_editor_settings = true;

        var message = {
          msg_type: "editor_settings"
        };

        jipt.send_post_message(message);
      },

      hotkeys_settings: function() {
        jipt.open_hotkeys_settings = true;

        var message = {
          msg_type: "hotkeys_settings"
        };

        jipt.send_post_message(message);
      },
      // do not specify parameters to reset preview
      place_translation_preview: function(id, value, plural_id) {
        jipt.translation_preview.id = id;
        jipt.translation_preview.value = value;
        jipt.translation_preview.plural_id = plural_id >= 0 ? plural_id : 0;

        if(!jipt.editor.currentTranslation) return;

        var elements = jipt.editor.currentTranslation.elements;
        var newValue;

        if(!elements) {
          return;
        }

        for(var i = 0; i < elements.length; i++) {
          newValue = jipt.phrase2preview(
            jipt.phrases[elements[i].id].data,
            elements[i].placeholders,
            elements[i].plural_id
          );

          if(elements[i].attr !== false) {
            newValue = config.before_dom_insert(newValue, elements[i].element, elements[i].attr);
          } else {
            newValue = config.before_dom_insert(newValue, elements[i].element);
          }

          if(newValue === false) {
            continue;
          }

          if(elements[i].attr !== false) {
            elements[i].element.setAttribute(elements[i].attr, newValue);
            if(config.touch_optimized && !jipt.touch_optimized) {
              jipt.hide_translation_badge(elements[i].element);
            }
          } else {
            // innerHTML is undefined in svg node
            if(elements[i].element.innerHTML !== undefined) {
              elements[i].element.innerHTML = newValue;
            } else {
              elements[i].element.textContent = newValue;
            }
          }

          if(jipt.touch_optimized) {
            jipt.show_translation_badge(elements[i].element);
          }
        }
        // XXX(joshuan): Let host know that the preview has changed
        if (config.ka_after_preview_updated) {
          config.ka_after_preview_updated();
        }
      },

      set_translations_preview: function() {
        var currentTranslation = jipt.editor.currentTranslation;

        for(var i in jipt.phrases) {
          jipt.editor.currentTranslation = jipt.phrases[i].data;
          jipt.place_translation_preview();
        }

        jipt.editor.currentTranslation = currentTranslation;
      },

      crowdin_each_element: function(element) {
        if(element.id === 'crowdin-translation-panel' || element.id === 'crowdin-editor') {
          return;
        }

        jipt.match_element_attributes(element);

        if(element.hasChildNodes()) {
          for(var i = 0; i < element.childNodes.length; i++) {
            jipt.crowdin_each_element(element.childNodes[i]);
            jipt.match_element_attributes(element.childNodes[i]);
          }
        }

        if(element && element.nodeType === 3 && element.nodeValue.length) {
          var startMatch = element.nodeValue.match(jipt.regexp.startPhrase);

          if(startMatch) {
            if(element.nodeValue.toLowerCase().indexOf(jipt.regexp.endPart(startMatch[1], startMatch[2])) > -1) {
              jipt.match_element_text(element, element.parentNode);
            } else {
              jipt.match_element_html(element, startMatch[1], startMatch[2]);
            }
          }
        }
      },

      match_element_text: function(textNode, parentNode) {
        if(!parentNode || parentNode.nodeName === 'SCRIPT' || !textNode.parentNode) return; // is this need?

        var exactMatch = textNode.nodeValue.match(jipt.regexp.exactPhrase);
        var siblingsCount = textNode.parentNode.childNodes.length;

        if(exactMatch && siblingsCount === 1) {
          if(jipt.phrases[exactMatch[1]]) {
            jipt.handle_element(textNode.parentNode, jipt.phrases[exactMatch[1]].data, exactMatch[2]);
          } else {
            jipt._load_phrases_delayed(textNode.nodeValue, function() {
              jipt.match_element_text(textNode, parentNode);
            });
          }
        } else {
          var replace = textNode.nodeValue.replace(jipt.regexp.globalPhrase, '<span class="crowdin_phrase">$&</span>');

          if(replace !== textNode.nodeValue) {
            $(textNode).replaceWith(replace);

            for(var i = 0; i < parentNode.childNodes.length; i++) {
              var crowdinPhrase = parentNode.childNodes[i];

              if(crowdinPhrase.className === 'crowdin_phrase' && crowdinPhrase.firstChild.nodeType === 3) {
                jipt.match_element_text(crowdinPhrase.firstChild, crowdinPhrase);
              }
            }
          }
        }
      },

      match_element_html: function(textNode, id, plural_id) {
        if(!textNode.parentNode) return;

        var exactMatch = textNode.parentNode.innerHTML.match(jipt.regexp.exactPhrase);

        if(exactMatch) {
          if(jipt.phrases[exactMatch[1]]) {
            jipt.handle_element(textNode.parentNode, jipt.phrases[exactMatch[1]].data, exactMatch[2]);
          } else {
            jipt._load_phrases_delayed(textNode.parentNode.innerHTML, function() {
              jipt.match_element_html(textNode, id, plural_id);
            });
          }
        } else {
          var currentNode = textNode;
          var nodes = [];
          var html = '';
          var is_tags_broken = true;

          do {
            nodes.push(currentNode);
            html += currentNode.nodeValue ? htmlspecialchars(currentNode.nodeValue) : currentNode.outerHTML;

            if(currentNode.nodeType === 3 && currentNode.nodeValue.toLowerCase().indexOf(jipt.regexp.endPart(id, plural_id)) > -1) {
              is_tags_broken = false;
              break;
            } else {
              currentNode = currentNode.nextSibling;
            }
          } while(currentNode);

          if(is_tags_broken) {
            return;
          }

          html = html.replace(jipt.regexp.globalPhrase, '<span class="crowdin_phrase">$&</span>');
          var parentNode = textNode.parentNode;

          $(nodes[0]).before(html);

          for(var i = 0; i < nodes.length; i++) {
            parentNode.removeChild(nodes[i]);
          }

          for(var i = 0; i < parentNode.childNodes.length; i++) {
            var crowdinPhrase = parentNode.childNodes[i];

            if(crowdinPhrase.className === 'crowdin_phrase' && crowdinPhrase.firstChild.nodeType === 3) {
              jipt.crowdin_each_element(crowdinPhrase);
            }
          }
        }
      },

      match_element_attributes: function(element) {
        var attribute, new_value, i;
        var jq_element = $(element);

        if(element && element.attributes) {
          if(element.value && !element.getAttribute('value')) {
            element.setAttribute('value', element.value);
          }

          for(i = 0; i < element.attributes.length; i++) {
            attribute = element.attributes.item(i);

            new_value = attribute.nodeValue.replace(jipt.regexp.globalPhrase, function(match, phraseId, pluralId) {
              var phrase = jipt.phrases[phraseId];

              if(phrase) {
                jipt.translatable_placeholders = [];

                var source_segment = jipt.get_source_segment(phrase.data, pluralId);
                var placeholders = phrase.data.isIcu
                  ? jipt.get_icu_placeholders(source_segment, match)
                  : jipt.get_placeholders(source_segment, match, phrase.fileFormat);
                var result = jipt.phrase2preview(phrase.data, placeholders, pluralId);

                // store element only if exact match
                if(attribute.nodeValue.length === match.length) {
                  if(!phrase.data.elements) {
                    phrase.data.elements = [];
                    jipt.delayed_rebuild_panel_phrases();
                  }

                  var element_data = {
                    id: phrase.data.id,
                    element: element,
                    placeholders: placeholders,
                    attr: attribute.nodeName,
                    plural_id: pluralId
                  };

                  jipt.addPhraseToElement(jq_element, element_data);
                  phrase.data.elements.push(element_data);

                  for(var i = 0; i < jipt.translatable_placeholders.length; i++) {
                    var translatable_item = jipt.translatable_placeholders[i];

                    if(config.edit_strings_context) {
                      jipt.update_strings_context(translatable_item.phrase.id, translatable_item.phrase.context);
                    }

                    if(!translatable_item.phrase.elements) {
                      translatable_item.phrase.elements = [];
                      jipt.delayed_rebuild_panel_phrases();
                    }

                    jipt.addPhraseToElement(jq_element, {
                      id: translatable_item.phrase.id,
                      placeholders: translatable_item.placeholders,
                      attr: element_data.attr,
                      plural_id: translatable_item.plural_id
                    });

                    translatable_item.phrase.elements.push(element_data);
                  }

                  jq_element.addClass(jipt.element_classname(jq_element));

                  jq_element.mouseenter(function() {
                    jipt.hover_show_translation_badge(element);
                  });

                  if(jipt.touch_optimized) {
                    jipt.show_translation_badge(element);
                  }
                }

                if(config.edit_strings_context) {
                  jipt.update_strings_context(phrase.data.id, phrase.data.context);
                }

                return result;
              } else {
                jipt._load_phrases_delayed(match, function() {
                  jipt.match_element_attributes(element);
                });
                return match;
              }
            });

            if(attribute.nodeValue !== new_value) {
              new_value = config.before_dom_insert(new_value, element, attribute.nodeName);

              if(new_value !== false) {
                attribute.nodeValue = new_value;

                if(attribute.name === 'value') {
                  element.value = new_value;
                }
              }
            }
          }
        }
      },

      // source and target plurals is equal
      get_translation_segment: function(phrase, plural_id) {
        plural_id = parseInt(plural_id);
        plural_id = plural_id ? plural_id : 0;

        if(phrase.translation[plural_id] !== undefined) {
          return phrase.translation[plural_id];
        } else {
          return phrase.translation[0];
        }
      },

      get_source_segment: function(phrase, plural_id) {
        plural_id = parseInt(plural_id);
        plural_id = plural_id ? plural_id : 0;

        if(phrase.text[plural_id] !== undefined) {
          return phrase.text[plural_id];
        } else {
          return phrase.text[0];
        }
      },

      get_placeholders: function(source_segment, jipt_segment, file_format) {
        var keys = [];
        var values = [];
        var regexpPlaceholders = jipt.regexp.placeholders[file_format] || jipt.regexp.placeholders['default'];
        var matchedKeys = source_segment.match(regexpPlaceholders);
        var matchedValues = jipt_segment.match(jipt.regexp.exactPhrase);

        if(matchedValues && matchedValues[3]) {
          var delimiter = jipt.regexp.delimiterPart(matchedValues[1], matchedValues[2]);

          if(matchedValues[3].toLowerCase().indexOf(delimiter) >= 0) {
            values = jipt.split(matchedValues[3], delimiter);
          } else {
            values = [matchedValues[3]];
          }
        }

        if(matchedKeys !== null) {
          keys = matchedKeys;
        }

        return [keys, values];
      },

      get_icu_placeholders: function(source_segment, jipt_segment) {
        var keys = [];
        var values = [];
        var matched;

        var matchedValues = jipt_segment.match(jipt.regexp.exactPhrase);
        if(matchedValues && matchedValues[3]) {
          var delimiter = jipt.regexp.delimiterPart(matchedValues[1], matchedValues[2]);

          if(matchedValues[3].toLowerCase().indexOf(delimiter) >= 0) {
            matched = jipt.split(matchedValues[3], delimiter);
          } else {
            matched = [matchedValues[3]];
          }
        }

        for(var i = 0; i < matched.length; i++) {
          var result_split = matched[i].split('=');
          keys.push(result_split.shift());
          values.push(result_split.join('='));
        }

        return [keys, values];
      },

      // this is ugly hack for HTML title preview. Sorry about that
      handle_document_title: function(title) {
        if(!title.firstChild) { // disable this in ie8 and earlier
          return;
        }

        title.innerHTML = jipt.regexp.wrapText(title.innerHTML);

        jipt.phrases['0'] = {
          data: {
            id: '0',
            text: ['%s'],
            translation: [''],
            hidden: '0',
            status: 'translated'
          }
        };

        jipt.match_element_text(title.firstChild, title);
      },

      is_editor_element: function(jq_element) {
        return '#crowdin-editor' === jq_element.data('id')
      },

      handle_element: function(element, phrase, plural_id) {
        var newValue;
        var currentValue;
        var placeholderValues;
        var jq_element = $(element);
        var source_segment = jipt.get_source_segment(phrase, plural_id);

        this.translatable_placeholders = [];

        // innerHTML is undefined for svg nodes
        currentValue = element.innerHTML !== undefined ? element.innerHTML : element.textContent;
        placeholderValues = phrase.isIcu
          ? jipt.get_icu_placeholders(source_segment, currentValue)
          : jipt.get_placeholders(source_segment, currentValue, phrase.fileFormat);

        newValue = jipt.phrase2preview(phrase, placeholderValues, plural_id);

        if(config.edit_strings_context) {
          jipt.update_strings_context(phrase.id, phrase.context);
        }

        // XXX(kevinb) Pass in the current value so that know which
        // jiptString corresponds to which element.
        newValue = config.before_dom_insert(newValue, element, null, currentValue);

        if(newValue !== false) {
          if(element.innerHTML !== undefined) {
            element.innerHTML = newValue;
          } else {
            element.textContent = newValue;
          }
        }

        var element_data = {
          id: phrase.id, // refference to phrase (used for translatable placeholders)
          element: element,
          placeholders: placeholderValues,
          attr: false,
          plural_id: plural_id
        };

        if(!phrase.elements) {
          phrase.elements = [];
          jipt.delayed_rebuild_panel_phrases();
        }

        jipt.addPhraseToElement(jq_element, element_data);
        phrase.elements.push(element_data);

        for(var i = 0; i < this.translatable_placeholders.length; i++) {
          if(!this.translatable_placeholders[i].phrase.elements) {
            this.translatable_placeholders[i].phrase.elements = [];
            jipt.delayed_rebuild_panel_phrases();
          }

          if(config.edit_strings_context) {
            jipt.update_strings_context(this.translatable_placeholders[i].phrase.id, this.translatable_placeholders[i].phrase.context);
          }

          jipt.addPhraseToElement(jq_element, {
            id: this.translatable_placeholders[i].phrase.id,
            placeholders: this.translatable_placeholders[i].placeholders,
            attr: element_data.attr,
            plural_id: this.translatable_placeholders[i].plural_id
          });

          this.translatable_placeholders[i].phrase.elements.push(element_data);
        }

        if (!jipt.is_editor_element(jq_element)) {
          jq_element.addClass(jipt.element_classname(jq_element));
        }

        if(jq_element.is('option') || jq_element.parent().is('option')) {
          var select_element = jq_element.closest('select');

          if(select_element) {
            select_element.addClass(jipt.element_classname(select_element));
            element = select_element.get(0);
          }
        }

        if(jipt.editor.currentTranslation && jipt.editor.currentTranslation.id === +phrase.id) {
          jipt.editor.currentTranslation = phrase;
          jipt.update_active_phrase_highlight(); // add selected class if loaded phrase already in editor
        }

        $(element).off('mouseenter').mouseenter(function() {
          jipt.hover_show_translation_badge(element);
        });

        if(jipt.touch_optimized && !$(element).is('select')) {
          jipt.show_translation_badge(element);
        }
      },

      phrase2preview: function(phrase, placeholders, plural_id) {
        var translation = jipt.get_translation_segment(phrase, plural_id);
        var preview_enabled = jipt.pluralsPreview || phrase.text.length === 1;

        var translation_preview = '';
        if(this.translation_preview.id === phrase.id && +this.translation_preview.plural_id === +plural_id) {
          translation_preview = this.translation_preview.value;
        }

        if(preview_enabled && jipt.translations_preview === true && translation_preview.length) {
          return phrase.isIcu
            ? jipt.replace_placeholders_icu(translation_preview, placeholders)
            : jipt.replace_placeholders(translation_preview, placeholders, phrase.fileFormat);
        }

        if(preview_enabled && jipt.translations_preview === true && translation.length) {
          return phrase.isIcu
            ? jipt.replace_placeholders_icu(translation, placeholders)
            : jipt.replace_placeholders(translation, placeholders, phrase.fileFormat);
        }

        var content = jipt.get_source_segment(phrase, plural_id);

        return phrase.isIcu
          ? jipt.replace_placeholders_icu(content, placeholders)
          : jipt.replace_placeholders(content, placeholders, phrase.fileFormat);
      },

      replace_placeholders_icu: function(text, stored_placeholders) {
        // no need to change stored placeholders
        var keys = stored_placeholders[0].slice(0);
        var values = stored_placeholders[1].slice(0);
        for(var i = 0; i < values.length; i++) {
          values[i] = values[i].replace(jipt.regexp.globalPhrase, function(match, phrase_id, plural_id) {
            var phrase = jipt.phrases[phrase_id];

            if(phrase && phrase.data) {
              var source_segment = jipt.get_source_segment(phrase.data, plural_id);
              var placeholders = phrase.data.isIcu
                ? jipt.get_icu_placeholders(source_segment, match)
                : jipt.get_placeholders(source_segment, match, phrase.fileFormat);

              jipt.translatable_placeholders.push({
                phrase: phrase.data,
                placeholders: placeholders,
                plural_id: plural_id
              });

              return jipt.phrase2preview(phrase.data, placeholders, plural_id);
            } else {
              return match;
            }
          });
        }

        var obj = {};
        var icu_parser = new MessageFormatLight(jipt.language.code);
        for(var i = 0; i < keys.length; i++ ) {
          obj[keys[i]] = values[i];
        }

        text = icu_parser.compiler(text, obj);
        if(!text) {
          return jipt.insert_source_text_in_dom();
        }

        return jipt.sanitizing_text(text);
      },

      insert_source_text_in_dom: function() {
        var text;
        var current_translation = jipt.editor.currentTranslation;

        if(current_translation.isIcu) {
          var placeholders = current_translation.elements[0].placeholders;
          var obj = {};
          var icu_parser = new MessageFormatLight(jipt.language.code);
          for(var i = 0; i < placeholders[0].length; i++ ) {
            obj[placeholders[0][i]] = placeholders[1][i];
          }

          text = icu_parser.compiler(current_translation.text[0], obj);
        } else {
          text = jipt.get_source_segment(current_translation, current_translation.elements[0].plural_id);
        }

        return jipt.sanitizing_text(text);
      },

      sanitizing_text: function(text) {
        if (!text || typeof text !== 'string') {
          return '';
        }

        // Remove dangerous HTML tags
        const dangerousTags = [
          'meta', 'base', 'iframe', 'object', 'embed', 'script',
          'style', 'isindex', 'applet', 'form', 'input', 'svg',
          'marquee', 'details', 'xss', 'link'
        ];
        text = sanitizer.tags(text, dangerousTags);

        // Remove dangerous attributes
        text = sanitizer.attributes(text);

        // Remove event handlers and javascript: URLs
        text = text.replace(/\b(on\w+=(["'])?[^"']*?\2)/gi, '');
        text = text.replace(/javascript:/gi, '');
        text = text.replace(/data:/gi, '');
        text = text.replace(/vbscript:/gi, '');

        // Remove formaction, formtarget and other form-related attributes
        text = text.replace(/\b(form\w+=(["'])?[^"']*?\2)/gi, '');

        // Remove opener references
        text = text.replace(/\bopener\b/gi, '');

        // XXX(aasmund): Removed the replacing of \n with newlines,
        // as that is now handled by maybeUnescape(). However, this
        // might have unintended side effects if the result is rendered
        // by something else than Perseus. Not sure if that might
        // actually happen or not.
        // Handle newlines
        // if (config.preserve_newlines !== false) {
        //   text = text.replace(/\\n/g, '\n');
        // }

        // Trim whitespace
        text = text.trim();

        // Encode special characters except for HTML attributes
        // Only encode quotes that are not part of HTML attributes
        text = text.replace(/['"]/g, function(match, offset, string) {
          var beforeMatch = string.substring(0, offset);
          var afterMatch = string.substring(offset);

          var lastOpenTag = beforeMatch.lastIndexOf('<');
          var lastCloseTag = beforeMatch.lastIndexOf('>');

          var nextCloseTag = afterMatch.indexOf('>');

          if (lastOpenTag > lastCloseTag && nextCloseTag !== -1) {
            return match;
          }

          return '&#' + match.charCodeAt(0) + ';';
        });

        return text;
      },

      replace_placeholders: function(text, stored_placeholders, file_format) {
        // no need to change stored placeholders
        var keys = stored_placeholders[0].slice(0);
        var values = stored_placeholders[1].slice(0);

        for(var i = 0; i < values.length; i++) {
          values[i] = values[i].replace(jipt.regexp.globalPhrase, function(match, phrase_id, plural_id) {
            var phrase = jipt.phrases[phrase_id];

            if(phrase && phrase.data) {
              var source_segment = jipt.get_source_segment(phrase.data, plural_id);
              var placeholders = phrase.data.isIcu
                ? jipt.get_icu_placeholders(source_segment, match)
                : jipt.get_placeholders(source_segment, match, file_format);

              jipt.translatable_placeholders.push({
                phrase: phrase.data,
                placeholders: placeholders,
                plural_id: plural_id
              });

              return jipt.phrase2preview(phrase.data, placeholders, plural_id);
            } else {
              return match;
            }
          });
        }

        if(values.length > 0) {
          var regexpPlaceholders = jipt.regexp.placeholders[file_format] || jipt.regexp.placeholders['default'];
          text = text.replace(regexpPlaceholders, function(match) {
            for(var i = 0; i < keys.length; i++) {
              if(keys[i] === match && values[i] !== undefined) {
                var result = values[i];

                keys.splice(i, 1);
                values.splice(i, 1);

                return result;
              }
            }

            return match;
          });
        }

        return jipt.sanitizing_text(text);
      },

      get_element_position: function(node) {
        var offsetLeft = 0;
        var offsetTop = 0;

        var rect = node.getBoundingClientRect();
        offsetLeft = rect.left;
        offsetTop = rect.top;

        return {left: offsetLeft, top: offsetTop, position: 'fixed'};
      },

      create_translation_badge: function(element) {
        var badge_id = 'crowdin-translation-badge';
        var badge = $('#' + badge_id);
        var touch = false;

        if(jipt.touch_optimized && !$(element).is('area, base, br, col, command, embed, hr, img, input, textarea, wbr')) {
          touch = true;
        }

        if(!badge.length || touch) { // touch optimized or first time badge creation
          var zIndex = jipt.dialog_zindex;

          badge = $('<span data-html2canvas-ignore="true" class="crowdin-jipt"><span class="jipt-badge-inner"></span></span>');

          if(!touch) {
            badge.
            attr('id', badge_id).
            css('position', 'fixed').
            css('z-index', --zIndex).
            appendTo('body').
            mouseleave(function() {
              jipt.hide_translation_badge();
            });
          } else if($(element).children('.' + badge_id).length === 0) {
            badge.
            addClass(badge_id).
            prependTo($(element));
          }
        }

        if(!touch) {
          var elementPosition = jipt.get_element_position(element);

          badge.
          css('top', (elementPosition.top - 7) + 'px').
          css('left', (elementPosition.left - 7) + 'px').
          css('position', elementPosition.position);
        }

        return badge;
      },

      get_element_data: function(element) {
        var phrases = [];
        var is_parent_element = false;

        if(!$(element).data('phrases')) {
          var child_elements = $(element).find('[class*=crowdin_jipt]');
          if(child_elements.length) {
            phrases = child_elements.first().data('phrases');
            is_parent_element = true;
          } else {
            return; // This element has no translatable phrases.
          }
        } else {
          phrases = $(element).data('phrases');
        }

        return {
          is_parent_element: is_parent_element,
          phrases: phrases,
          phrase: jipt.phrases[phrases[0].id].data
        };
      },

      show_translation_badge: function(element) {
        jipt.active_translation = element;

        var element_data = jipt.get_element_data(element);
        if(!element_data) { return; }

        var phrase = element_data.phrase;
        var badge = jipt.create_translation_badge(element);

        if(element_data.is_parent_element) {
          element = $(element).find('[class*=crowdin_jipt]').get(0);
        }

        badge.
        show().
        off('click').
        on('click', function(e) {
          if(
            element_data.phrases.length > 1
            || phrase.hidden
            || jipt.get_phrase_status(phrase.status) === jipt.status.not_found
            || jipt.get_phrase_status(phrase.status) === jipt.status.not_visible_on_step
            || jipt.get_phrase_status(phrase.status) === jipt.status.file_not_available_for_language
          ) {
            jipt.show_badge_popup(element, element_data.phrases);
          } else {
            jipt.show_editor(phrase, element);
          }
          e.stopPropagation();
          e.preventDefault();
          return false;
        });
      },

      hover_show_translation_badge: function(element) {
        if(!jipt.touch_optimized || $(element).is('select')) {
          setTimeout(function() {
            jipt.show_translation_badge(element);
          }, 1);
        } else if($(element).children('.crowdin-translation-badge').length === 0) {
          setTimeout(function() {
            jipt.show_translation_badge(element);
          }, 1);
        }
      },

      show_badge_popup: function(element, phrases) {
        jipt.hide_translation_badge();
        var elementPosition = jipt.get_element_position(element);
        var list = '<ul>';

        if(!$('#crowdin-translation-badge-popup').length) {
          $('body').append($('<div>').
          attr('id', 'crowdin-translation-badge-popup').
          addClass('crowdin-jipt').
          css({
            'position': 'absolute',
            'z-index': jipt.dialog_zindex - 1,
            'display': 'none'
          }));
        } else {
          $('#crowdin-translation-badge-popup').html('');
        }

        $('#crowdin-translation-badge-popup').
        css('top', elementPosition.top + 'px').
        css('left', elementPosition.left + 'px').
        css('position', elementPosition.position);

        for(var i = 0; i < phrases.length; i++) {
          var id = phrases[i].id;
          var not_found_string = jipt.get_phrase_status(jipt.phrases[id].data.status) === jipt.status.not_found;
          var not_visible_on_step = jipt.get_phrase_status(jipt.phrases[id].data.status) === jipt.status.not_visible_on_step;
          var file_not_available_for_language = jipt.get_phrase_status(jipt.phrases[id].data.status) === jipt.status.file_not_available_for_language;
          var disabled_class = (!jipt.user.isLeader && jipt.phrases[id].data.hidden) || not_found_string || not_visible_on_step || file_not_available_for_language ? 'disabled' : '';
          var status_class = jipt.phrase_classname(jipt.phrases[id].data) + '_popup';

          list += '<li class="' + disabled_class + '"><a href="javascript:void(0)" data-id="' + id + '" class="popup-phrase ' + status_class +'">';

          if(phrases[i].attr) {
            list += '<span class="popup-phrase-attr">' + phrases[i].attr + ':</span>';
          }

          if(jipt.phrases[id].data.hidden) {
            list += '<span class="popup-phrase-attr">This string is hidden and should not be translated.</span>';
          }

          if(not_found_string) {
            list += '<span class="popup-phrase-attr">String is not loaded. Probably it has been deleted.</span>';
          }

          if(not_visible_on_step) {
            list += '<span class="popup-phrase-attr">This string is not included in the workflow step</span>';
          }

          if(file_not_available_for_language) {
            list += '<span class="popup-phrase-attr">Seems like ' + jipt.language.name + ' is not enabled as a target language <br>for the file this string comes from.</span>';
          }

          var placeholders = [[],[]];

          if (jipt.phrases[id].data.isIcu) {
            placeholders = phrases[i].placeholders;
          }

          var preview = jipt.phrase2preview(jipt.phrases[id].data, placeholders, phrases[i].plural_id);
          list += $('<span>' + preview + '</span>').text();

          list += '</a></li>';
        }

        list += '</ul>';
        $('#crowdin-translation-badge-popup').html(list).show();

        $('#crowdin-translation-badge-popup li:not(.disabled) a.popup-phrase').click(function(e) {
          var id = $(e.target).closest('a.popup-phrase').data('id');
          $('#crowdin-translation-badge-popup').hide();
          jipt.show_editor(jipt.phrases[id].data, element);
          return false;
        });

        jipt.autoHideBadgePopup();
      },

      autoHideBadgePopup: function() {
        $(document).one('utapstart mousedown', function(e) {
          if($(e.target).closest('#crowdin-translation-badge-popup').length === 0) {
            $('#crowdin-translation-badge-popup').hide();
          } else {
            jipt.autoHideBadgePopup();
          }
        });
      },

      hide_translation_badge: function(element) {
        jipt.active_translation = null;

        $('#crowdin-translation-badge').hide();
        if(typeof element !== 'undefined') {
          $(element).children('.crowdin-translation-badge').remove();
        }
      },

      // active phrase in the DOM
      update_active_phrase_highlight: function() {
        $('.jipt-selected').removeClass('jipt-selected');

        if(jipt.editor.currentTranslation.elements) {
          for(var i = 0; i < jipt.editor.currentTranslation.elements.length; i++) {
            var jq_element = $(jipt.editor.currentTranslation.elements[i].element);

            jq_element.addClass('jipt-selected');

            if(jq_element.is('option') || jq_element.parent().is('option')) {
              var select_element = jq_element.closest('select');

              if(select_element) {
                select_element.addClass('jipt-selected');
              }
            }
          }
        }
      },

      highlight_panel_opened_phrase: function() {
        if(jipt.editor.currentTranslation) {
          jipt.translationDialog.content.find('#jipt-translations').
          find('li.active').
          removeClass('active');
          jipt.translationDialog.content.find('#jipt-translations').
          find('a[rel=' + jipt.editor.currentTranslation.id + ']').
          parent().
          addClass('active');
        }
      },

      // phrases status in the DOM
      update_phrase_dom_highlight: function() {
        if(jipt.editor.currentTranslation.elements) {
          for(var i = 0; i < jipt.editor.currentTranslation.elements.length; i++) {
            var element = jipt.editor.currentTranslation.elements[i].element;
            var jq_element = $(element);
            var class_name = jipt.element_classname(jq_element);

            jq_element.removeClass(function(index, css) {
              return (css.match(/\bcrowdin_jipt_\S+/g) || []).join(' ');
            }).addClass(class_name);

            if(jq_element.is('option') || jq_element.parent().is('option')) {
              var select_element = jq_element.closest('select');

              if(select_element) {
                select_element.removeClass(function(index, css) {
                  return (css.match(/\bcrowdin_jipt_\S+/g) || []).join(' ');
                });

                for(var name in jipt.status) {
                  if(select_element.find('[class*=crowdin_jipt_' + jipt.status[name] + ']').length) {
                    select_element.addClass('crowdin_jipt_' + jipt.status[name]);
                  }
                }
              }
            }
          }
        }
      },

      // phrase status in the translation panel
      update_phrase_highlight: function() {
        if(jipt.editor.currentTranslation) {
          var class_name = jipt.phrase_classname(jipt.editor.currentTranslation) + '_item';
          var jq_element = jipt.translationDialog.content.find('#jipt-translations a[rel=' + jipt.editor.currentTranslation.id + ']');

          jq_element.removeClass(function(index, css) {
            return (css.match(/\bcrowdin_jipt_\S+/g) || []).join(' ');
          }).addClass(class_name);
        }
      },

      // NOTE(danielhollas): A new helper function for determining the correct CSS selector.
      // TODO(danielhollas): Generalize this so that we can ask Crowdin to upstream
      // this functionality. Instead of `inTranslationEditor` we could have `selector_prefix`
      // passed via config.
      get_phrase_selector: function(select_translated, inTranslationEditor) {
        var selector_list = ['.crowdin_jipt_untranslated', '.crowdin_jipt_partially_translated'];
        if (select_translated) {
            selector_list.push('.crowdin_jipt_translated');
            selector_list.push('.crowdin_jipt_partially_approved');
        }
        if (inTranslationEditor) {
            selector_list = selector_list.map(sel => '#translations-dashboard ' + sel);
        }
        return selector_list.join(',');
      },

      get_next_phrase: function(active_element) {
        var result = {id: null, element: null};
        var element = $(active_element);

        if(element.length) {
          var next_id = jipt.get_first_untranslated(element, 'next', true);

          if(!next_id) {
            // NOTE(danielhollas): A generalized way to get a proper CSS selector.
            var selector = jipt.get_phrase_selector(false, config.inTranslationEditor);
            element = jipt.findNext('next', element, selector) || jipt.findNext('next', $(document), selector);

            if(!element) { return result; } // end of phrases

            next_id = jipt.get_first_untranslated(element);

            if(!parseInt(next_id)) {
              return jipt.get_next_phrase(element);
            }
          }

          result.id = next_id;
          result.element = element;
        }

        return result;
      },

      // NOTE(danielhollas): If we didn't find any untranslated strings,
      // we call this new function which searches for translated (but not approved)
      // strings as well. It's mostly the same as `get_next_phrase()`,
      // but with a different CSS selector and calling `get_first_unapproved()`
      // instead of `get_first_untranslated()`.
      get_next_phrase_translated: function(active_element) {
        var result = {id: null, element: null};
        var element = $(active_element);

        if(element.length) {
          var next_id = jipt.get_first_unapproved(element, 'next', true);

          if(!next_id) {
            var selector = jipt.get_phrase_selector(true, config.inTranslationEditor);
            element = jipt.findNext('next', element, selector) || jipt.findNext('next', $(document), selector);

            if(!element) { return result; } // end of phrases

            next_id = jipt.get_first_unapproved(element);

            if(!parseInt(next_id)) {
              return jipt.get_next_phrase_translated(element);
            }
          }

          result.id = next_id;
          result.element = element;
        }

        return result;
      },

      get_prev_phrase: function(active_element) {
        var result = {id: null, element: null};
        var element = $(active_element);

        if(element.length) {
          var prev_id = jipt.get_first_untranslated(element, 'prev', true);

          if(!prev_id) {
            // NOTE(danielhollas): A generalized way to get a proper CSS selector.
            var selector = jipt.get_phrase_selector(false, config.inTranslationEditor);
            element = jipt.findNext('prev', element, selector);

            if(element.length) {
              prev_id = jipt.get_first_untranslated(element, 'prev');

              if(!parseInt(prev_id)) {
                return jipt.get_prev_phrase(element);
              }
            }
          }

          result.id = prev_id;
          result.element = element;
        }

        return result;
      },

      // NOTE(danielhollas): See comment for get_next_phrase_translated above.
      get_prev_phrase_translated: function(active_element) {
        var result = {id: null, element: null};
        var element = $(active_element);

        if(element.length) {
          var prev_id = jipt.get_first_unapproved(element, 'prev', true);

          if(!prev_id) {
            var selector = jipt.get_phrase_selector(true, config.inTranslationEditor);
            element = jipt.findNext('prev', element, selector);

            if(element.length) {
              prev_id = jipt.get_first_unapproved(element, 'prev');

              if(!parseInt(prev_id)) {
                return jipt.get_prev_phrase_translated(element);
              }
            }
          }

          result.id = prev_id;
          result.element = element;
        }

        return result;
      },

      show_next_element: function(active_element) {
        var next_phrase = jipt.get_next_phrase(active_element);
        // NOTE(danielhollas): We didn't find any untranslated string
        // so we find first unapproved string.
        // TODO(danielhollas): It would be nice to only do this when the translator
        // has proofreader permissions. Unfortunately, it seems this info is not available here.
        // See jipt.user for the currently available info.
        if (!next_phrase.id) {
          next_phrase = jipt.get_next_phrase_translated(active_element);
        }

        if(!next_phrase.id) {
          // NOTE(danielhollas): In the original jipt.js, the strings annotated with .crowdin_phrase
          // were selected even if they were translated and approved.
          var selector = '.crowdin_phrase:not(.crowdin_jipt_approved)';
          if (config.inTranslationEditor) {
            selector = '#translations-dashboard ' + selector;
          }
          var element = jipt.findNext('next', $(active_element), selector) || jipt.findNext('next', $(document), selector);

          if(element) {
            jipt.show_editor(jipt.get_element_data(element).phrase, element);
          }

          jipt.refresh_suggestions();
          return;
        }

        jipt.show_editor(jipt.phrases[next_phrase.id].data, next_phrase.element.get(0));
      },

      show_prev_element: function(active_element) {
        var prev_phrase = jipt.get_prev_phrase(active_element);
        // NOTE(danielhollas): Same new logic as in show_next_element
        if (!prev_phrase.id) {
         prev_phrase = jipt.get_prev_phrase_translated(active_element);
        }

        if(!prev_phrase.id) {
          var selector = '.crowdin_phrase:not(.crowdin_jipt_approved)';
          if (config.inTranslationEditor) {
            selector = '#translations-dashboard ' + selector;
          }
          var element = jipt.findNext('prev', $(active_element), selector) || jipt.findNext('prev', $(document), selector);

          if(element) {
            var phrase = jipt.get_element_data(element).phrase;
            if (!phrase.visibleOnStep) {
              jipt.show_prev_element(element[0]);

              return;
            }

            jipt.show_editor(phrase, element);
          }

          return;
        }

        jipt.show_editor(jipt.phrases[prev_phrase.id].data, prev_phrase.element.get(0));
      },

      // NOTE(danielhollas): The original function get_first_untranslated was renamed to
      // get_first_with_status, and this is just a thin wrapper around it.
      get_first_untranslated: function(element, direction, self_only) {
        var status_list = [this.status.untranslated, this.status.partially_translated];
        return jipt.get_first_with_status(element, status_list, direction, self_only);
      },

      // NOTE(danielhollas): A new helper function to find first unapproved string.
      get_first_unapproved: function(element, direction, self_only) {
        var status_list = [this.status.untranslated, this.status.partially_translated,
                           this.status.translated, this.status.partially_approved];
        return jipt.get_first_with_status(element, status_list, direction, self_only);
      },

      // NOTE(danielhollas): This is basically the same function as get_first_untranslated()
      // in the original jipt, but it is generalized by passing in the status_list that
      // we try to match.
      get_first_with_status: function(element, status_list, direction, self_only) {
        var id = null;

        if(element.data('phrases')) {
          var phrases = element.data('phrases').slice();
          var reached_active_phrase = false;

          if(direction === 'prev') {
            phrases.reverse();
          }

          for(var i = 0; i < phrases.length; i++) {
            var phrase = jipt.phrases[phrases[i].id].data;

            // phrase.id !== '0' - skip phrase at document.title with manually setted id
            var phrase_status = this.get_phrase_status(phrase.status);
            if (status_list.includes(phrase_status) && phrase.hidden !== '1' && phrase.id !== '0') {
              if(self_only) {
                if(reached_active_phrase) {
                  id = phrase.id;
                  break;
                }
                if(phrase.id === jipt.editor.currentTranslation.id) {
                  reached_active_phrase = true;
                }
              } else {
                id = phrase.id;
                break;
              }
            }
          }
        }

        return id;
      },

      show_settings: function(mode) {
        mode === 'hotkeys' ? jipt.hotkeys_settings() : jipt.editor_settings();
        $('.jipt-dialog-title h4', '.jipt-editor-dialog').text(mode === 'hotkeys' ? 'Hotkeys Settings' : 'Editor Settings');
        jipt.editorDialog.jiptDialog({action: 'open'});
      },

      show_editor: function(string, element) {
        if(!jipt.user.isLoggedIn) {
          alert('Login first to be able submit translations');
          jipt.show_login_panel();
          return;
        }

        jipt.place_translation_preview();
        jipt.editor.currentTranslation = string;

        if(element) {
          jipt.editor.currentTranslation.active_element = element;
        } else if (jipt.editor.currentTranslation.elements) {
          jipt.editor.currentTranslation.active_element = jipt.editor.currentTranslation.elements[0].element;
        }

        jipt.update_active_phrase_highlight();
        jipt.editorDialog.jiptDialog({action: 'open'});
        jipt.editorDialog.jiptDialog({action: 'toggle_minimized_show'});
        jipt.highlight_panel_opened_phrase();

        var preload_ids = [];

        if(jipt.editor.currentTranslation.active_element) {
          var prev_phrase_id = jipt.get_prev_phrase(jipt.editor.currentTranslation.active_element).id;
          var next_phrase_id = jipt.get_next_phrase(jipt.editor.currentTranslation.active_element).id;

          next_phrase_id && preload_ids.push(+next_phrase_id);
          prev_phrase_id && preload_ids.push(+prev_phrase_id);
        }

        jipt.show_string(string.id, preload_ids);
      },

      show_string: function(string_id, preload_ids) {
        var message = {
          msg_type: 'show_string',
          id: string_id,
          preload_ids: preload_ids
        };

        jipt.send_post_message(message);
      },

      refresh_suggestions: function() {
        var message = {msg_type: 'refresh_suggestions'};

        jipt.send_post_message(message);
      },

      _get_target_languages_options: function() {
        var language_code = Storage.get('language_code');
        var options = '';
        var selected = '';

        for(var i = 0; i < jipt.target_languages.length; i++) {
          selected = '';
          if(jipt.target_languages[i].code === language_code) {
            selected = 'selected';
          }

          options += '<option value="' + jipt.target_languages[i].code + '" data-id="' + jipt.target_languages[i].id + '" ' + selected + ' >';
          options += jipt.target_languages[i].name;
          options += '</option>';
        }

        return options;
      },

      getWorkflowStepsOptions: function(languageCode) {
        var workflowStepId = Storage.get('workflow_step_id');
        var options = '';
        var workflowSteps = [{id: 0, title: 'All Content'}];

        if (jipt.workflowSteps.length) {
          jipt.workflowSteps.forEach(function (element) {
            const workflowStepCodes = element.languages.map(function (value) {
              return value['code'];
            })
            if (workflowStepCodes.indexOf(languageCode) >= 0) {
              workflowSteps.push(element);
            }
          })

          for (var i = 0; i < workflowSteps.length; i++) {
            var opt = document.createElement('option');
            opt.value = workflowSteps[i].id;
            opt.innerHTML = workflowSteps[i].title + (workflowSteps[i].type ? ' (' + workflowSteps[i].type + ')' : '');

            if (+workflowSteps[i].id === +workflowStepId) {
              opt.defaultSelected = true;
            }

            options += opt.outerHTML;
          }
        }

        return options;
      },

      show_login_panel: function() {
        var loginLanguageField = jipt.loginDialog.content.find('#crowdin-login-language-field');
        loginLanguageField.html(jipt._get_target_languages_options());

        if (jipt.getWorkflowStepsOptions($(loginLanguageField).val())) {
          jipt.loginDialog.content.find('#crowdin-login-workflow-step-field').html(
            jipt.getWorkflowStepsOptions($(loginLanguageField).val())
          ).parents('.workflow-step-group').removeClass('hide');
        }

        jipt.loginDialog.content.find('.crowdin-languages-panel').hide();
        jipt.loginDialog.content.find('.crowdin-login-panel').show();
        jipt.loginDialog.jiptDialog({action: 'open', position: 'center'});
        jipt.loginDialog.content.find('#crowdin-login-field').focus();

        jipt.place_close_btn();
      },

      show_languages_panel: function() {
        var languageField = jipt.loginDialog.content.find('#crowdin-language-field');
        languageField.html(jipt._get_target_languages_options());

        if (jipt.getWorkflowStepsOptions($(languageField).val())) {
          jipt.loginDialog.content.find('#crowdin-workflow-step-field').html(
            jipt.getWorkflowStepsOptions($(languageField).val())
          ).parents('.workflow-step-group').removeClass('hide');
        }

        jipt.loginDialog.content.find('.crowdin-login-panel').hide();
        jipt.loginDialog.content.find('.crowdin-languages-panel').show();
        jipt.loginDialog.jiptDialog({action: 'open', position: 'center'});
      },

      set_current_language: function(code, id, name) {
        jipt.language.code = code;
        jipt.language.id = id;
        jipt.language.name = name;
        Storage.save('language_code', code);
        Storage.save('language_id', id);
        Storage.save('language_name', name);
      },

      setCurrentWorkflowStep: function(id, type) {
        jipt.workflowStep.id = id;
        jipt.workflowStep.type = type;
        Storage.save('workflow_step_id', id);
        Storage.save('workflow_step_type', type);
      },

      _login_action: function() {
        var language = jipt.loginDialog.content.find('#crowdin-login-language-field option:selected');
        jipt.set_current_language(language.val(), language.data('id'), language.html());

        var workflow_step = jipt.loginDialog.content.find('#crowdin-login-workflow-step-field option:selected');
        jipt.setCurrentWorkflowStep(workflow_step.val(), workflow_step.html());

        window.top.location.href = Url.getJiptPath('login');
      },

      _join_action: function() {
        window.top.location.href = Url.getJiptPath('join');
      },

      _logout_action: function() {
        var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
        var eventer = window[eventMethod];
        var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";

        Storage.delete('language_id');
        Storage.delete('language_code');
        Storage.delete('language_name');

        eventer(messageEvent, function(e) {
          if (e.data === 'logout') {
            window.location.reload();
          }
        },false);

        var iframe = document.createElement('iframe');

        iframe.style = 'display: none;';
        iframe.src = Url.getAuthEntryPoint('/logout');

        document.body.append(iframe);
      },

      search: function(query, strings) {
        if(Object.prototype.toString.call(strings) === '[object Object]') {
          strings = $.map(strings, function(el) { return el; });
        }

        for(var index = 0; index < strings.length; index++) {
          if(strings[index].toLowerCase().indexOf(query.toLowerCase()) !== -1) {
            return true;
          }
        }

        return false;
      },

      rebuild_panel_phrases: function(query, page) {
        jipt.translationDialog.content.find('.jipt-phrases-to-translate').html('');

        var list = '';
        var itemClass;
        var item_counter = 0;
        var items_on_page = 50;
        var pages = jipt.panel_pages;
        var current_page = 0;

        if (page && /^\+?(0|[1-9]\d*)$/.test(page)) {
          current_page = page;

          if (page >= pages) {
            current_page = pages - 1;
          }
        }

        var start_item = current_page * items_on_page;

        jipt.panel_page = current_page;

        for(var i in jipt.phrases) {
          var phrase = jipt.phrases[i].data;

          if(
            i === '0'
            || this.get_phrase_status(phrase.status) === jipt.status.not_found
            || !phrase.visibleOnStep
            || phrase.fileNotAvailableForLanguage
          ) {
            continue; // pseudo phrase for html title and not found
          }

          var disabled_class = !jipt.user.isLeader && phrase.hidden ? 'disabled' : '';
          var disabled_title = phrase.hidden ? 'title="This string is hidden and should not be translated."' : '';

          if(query && !this.search(query, phrase.text) && !this.search(query, phrase.translation)) {
            continue;
          }

          if(jipt.translations_filter === true) {
            if(!phrase.elements) {
              continue;
            }
          }

          if(item_counter < start_item || item_counter >= start_item + items_on_page) {
            item_counter++;
            continue;
          }

          itemClass = jipt.phrase_classname(phrase) + '_item';

          list += '<li ' + disabled_title + ' class="' + disabled_class + '"><a href="javascript:void(0)" class="' + itemClass + '" rel="' + i + '">';
          list += htmlspecialchars(phrase.text[0]);
          list += '</a></li>';

          item_counter++;
        }

        var no_items_help = jipt.translations_filter ? ' The search was made among the texts of current page.' : '';

        if (item_counter === 0) {
          list += '<li><div style="padding: 30px; text-align: center; color: #999">No items.' + no_items_help + '</div></li>';
        }

        jipt.translationDialog.content.find('.jipt-phrases-to-translate').html(list);

        pages = Math.ceil(item_counter/items_on_page);
        jipt.panel_pages = pages;

        if (pages < 2) {
          $('#translation_panel_paging').hide();
        } else {
          var input_size = (pages.toString(10)).length * 2 + 3;
          var prev_btn = $('#translation_panel_prev_page');
          var next_btn = $('#translation_panel_next_page');

          $('#translation_panel_current_page').attr({'size': input_size}).val((current_page + 1) + ' / ' + pages);

          current_page === 0 ? prev_btn.addClass('jipt-page-disabled') : prev_btn.removeClass('jipt-page-disabled');
          current_page + 1 === pages ? next_btn.addClass('jipt-page-disabled') : next_btn.removeClass('jipt-page-disabled');

          $('#translation_panel_paging').show();
        }
        jipt.highlight_panel_opened_phrase();
      },

      delayed_rebuild_panel_phrases: function() {
        clearTimeout(jipt.rebuild_panel_timeout);

        jipt.rebuild_panel_timeout = setTimeout(function() {
          jipt.rebuild_panel_phrases(jipt.panel_search_phrase, jipt.panel_page);
        }, 500);
      },

      getJoinProjectDialogTpl: function(data) {
        var entryPoint = Url.getEntryPoint(),
          joinRequestSent = data.joinRequestSent;

        var buttonUrl = entryPoint + (config.domain ? data.projectManagersUrl : data.languageUrl);
        var buttonText = config.domain ? 'contact project manager' : 'send request';

        var sendRequestBtn = Boolean(joinRequestSent) === false
          ? '<div style="padding: 0; margin: 25px 0 25px">' +
              '<a href="' + buttonUrl + '" target="_blank" class="jipt-btn">' + buttonText + '</a>' +
            '</div>'
          : '';
        var style = joinRequestSent ? 'style="padding: 15px 10px 20px 10px"' : '';

        return '' +
          '<div class="text-center jipt-plain-text-content"' + style + '>\n' +
            data.message +
            sendRequestBtn +
            '<p class="text-center">' +
              '<a href="#" id="jipt-select-language" style="margin-right: 10px;">Change Language</a>' + this.logoutLinkTpl() +
            '</p>' +
          '</div>';
      },

      mfaSettingsAndLogoutTpl: function(profileUrl) {
        return '' +
          '<p class="text-center">' +
            '<a target="_blank" href="' + Url.getEntryPoint() + profileUrl +'" style="margin-right: 10px;">Profile Settings</a>' + this.logoutLinkTpl() +
          '</p>';
      },

      logoutLinkTpl: function() {
        return '<a id="jipt-join-logout-error" href="#">Logout</a>';
      },

      _show_no_texts_warning: function() {
        var configURL = this.get_in_context_config_url(jipt);
        var helpURL = Url.getEntryPoint() + '/contacts';

        var warningDialogContent = '<div class="jipt-no-translations-content">' +
          '<strong>Crowdin In-Context was unable to identify translatable texts.</strong>' +
          '<p>Possible reasons:</p>' +
          '<ul style="margin-left: 15px; list-style-type: square">' +
          '<li>the pseudo-language is not integrated;</li>' +
          '<li>current application locale is not set to the language that contains Crowdin In-Context pseudo-language;</li>' +
          '<li>there are no translatable texts on this page.</li>' +
          '</ul>' +
          '<p>Check the <a target="_blank" href="' + configURL + '">integration guide</a> for more information ' +
          'or <a href="' + helpURL + '" target="_blank">contact Crowdin Support</a></p>' +
          '<div class="jipt-control-group">' +
          '<label class="jipt-checkbox"><input type="checkbox" id="skip_no_phrases_msg">Do not show this message again.</label>' +
          '</div>' +
          '</div>';

        var warningDialog = $('<div id="no_texts_warning">').html(warningDialogContent);

        warningDialog.content = warningDialog.jiptDialog({
          modal: false,
          width: '550px',
          height: '320px',
          iframe: true,
          drags: true,
          minimize_btn: false,
          icon: 'crowdin',
          custom_class: 'jipt-no-translations',
          title_pane: '<h4>Nothing to translate</h4>',
          buttons_pane: '<div style="text-align:right; margin: 8px 20px;">' +
            '<button type="button" class="jipt-btn jipt-dialog-close">Close</button>' +
            '</div>'
        });

        warningDialog.content.find('#skip_no_phrases_msg').click(function() {
          if($(this).prop('checked') == true) {
            Storage.save('no_phrases_warning_disabled', 'yes');
          } else {
            Storage.save('no_phrases_warning_disabled', 'no');
          }
        });

        warningDialog.jiptDialog({action: 'open'});
      },

      _show_error_dialog: function(msg, hideLogoutLink) {
        var view = msg;
        var hideLink = hideLogoutLink || false;

        if(hideLink === false) {
          view = msg +
            '<p class="text-center">' +
              this.logoutLinkTpl() +
            '</p>';
        }

        var errorDialog = $('<div>').html(view);

        var dialogConfig = {
          modal: true,
          width: '450px',
          drags: false,
          minimize_btn: false,
          close_btn: false,
          icon: 'crowdin',
          title_pane: '<h4>Crowdin In-Context</h4>',
        };

        errorDialog.jiptDialog(dialogConfig);
        errorDialog.jiptDialog({action: 'open'});
        jipt.place_close_btn();

        $('#jipt-join-logout-error').on('click', function() {
          jipt._logout_action();
        });

        $('#jipt-select-language').on('click', function() {
          errorDialog.jiptDialog({action: 'destroy'});

          // reset language
          jipt.set_current_language(undefined, null, undefined);
          jipt.init_project();

          jipt.show_languages_panel();
        });
      },

      _handle_jipt_error: function(data) {
        var msg = '';
        var configURL = data.projectId ? this.get_in_context_config_url(data) : '';
        var helpURL = Url.getEntryPoint() + '/contacts';

        switch(data.errorCode) {
          case 'auth_error':
            alert('Your session has expired. Please log in again');
            window.location.reload();
            break;
          case 'moderate_language':
            this._show_error_dialog(this.getJoinProjectDialogTpl(data.data), true);
            break;
          case 'project_not_found':
            this._show_error_dialog('<p class="text-center" style="margin: 0 0 10px; padding: 0;"><strong>Translation mode is unavailable.</strong>' +
              '<p class="text-center">Crowdin In-Context can not find appropriate project at Crowdin. ' +
              'Please contact project manager for further assistance.</p>');
            break;
          case 'jipt_disabled':
            if(data.data.isManager) {
              msg = '<p class="text-center" style="margin: 0 0 10px; padding: 0;"><strong>Crowdin In-Context is disabled for this project.</strong></p>' +
                '<p class="text-center">Check the <a target="_blank" href="' + configURL + '">integration guide</a> for more information ' +
                'or <a href="' + helpURL + '" target="_blank">contact Crowdin Support</a></p>';
            } else {
              msg = '<p class="text-center" style="margin: 0 0 10px; padding: 0;"><strong>Translation mode is currently disabled.</strong></p>' +
                '<p class="text-center">Please contact <a href="' + data.ownerUrl + '">project manager</a> for further assistance.</p>';
            }
            this._show_error_dialog(msg);
            break;
          case 'denied':
            this._show_error_dialog('<p class="text-center">Sorry, you do not have access to this project</p>');
            break;
          case 'mfa_denied':
            this._show_error_dialog('' +
              '<p class="text-center">' +
                'Project participants are required to have two-factor authentication enabled to be able to access the project' +
              '</p>' +
              this.mfaSettingsAndLogoutTpl(data.data.mfa_settings_url),
              true
            );
            break;
          case 'timeout':
            this._show_error_dialog('<p class="text-center">Oops. Could not load data from remote server</p>');
            break;
          case 'language_not_found':
            Storage.delete('language_id');
            Storage.delete('language_code');
            Storage.delete('language_name');

            this._show_error_dialog(
              '<p class="text-center">' +
                'The specified language was not found in your project' +
              '</p>',
              true
            );
            break;
          default:
            this._show_error_dialog(
              '<p class="text-center">' +
              'Something went wrong while performing request' +
              '</p>',
              true
            );
        }
      },

      element_classname: function($element) {
        if($element.is('select')) {
          var classes = [];

          for(var name in jipt.status) {
            if($element.find('[class*=crowdin_jipt_' + jipt.status[name] + ']').length) {
              classes.push('crowdin_jipt_' + jipt.status[name]);
            }
          }
          if($element.find('[class*=crowdin_jipt_no_preview]').length) {
            classes.push('crowdin_jipt_no_preview');
          }

          return classes.join(' ');
        }

        var phrases = $element.data('phrases') || [];
        var statuses = [];
        var no_preview_class = '';

        for(var i = 0; i < phrases.length; i++) {
          var phrase = jipt.phrases[phrases[i].id].data;
          statuses.push(jipt.phrase_classname(phrase));
          if(!no_preview_class) {
            no_preview_class = jipt.phrase_no_preview_classname(phrase);
          }
        }

        for(var name in jipt.status) {
          var status = 'crowdin_jipt_' + jipt.status[name];

          if($.inArray(status, statuses) >= 0) {
            return status + no_preview_class;
          }
        }

        return '' + no_preview_class;
      },

      phrase_no_preview_classname: function(phrase) {
        var classname = (jipt.pluralsPreview || phrase.text.length === 1) ? '' : ' crowdin_jipt_no_preview';
        return classname;
      },

      phrase_classname: function(phrase) {
        if(phrase.hidden) {
          return 'crowdin_jipt_hidden';
        }

        return 'crowdin_jipt_' + this.get_phrase_status(phrase.status);
      },

      addPhraseToElement: function(element, data) {
        var phrases = [];
        if(element.data('phrases')) {
          phrases = element.data('phrases');
        }

        for(var i = 0; i < phrases.length; i++) {
          if(+phrases[i].id === data.id) {
            return; // already exists
          }
        }

        phrases.push(data);
        element.data('phrases', phrases);
      },

      findNext: function(direction, element, selector) {

          // Return the next DOM element after the specified one
          // that matches the specified selector.
          function next(element, selector) {
              // If a descendant of this element matches, return it
              var descendant = element.querySelector(selector);
              if (descendant) {
                  return descendant;
              }
              // Otherwise, we can just skip the entire subtree under
              // this element and move on to its next sibling
              var next = element.nextElementSibling;
              if (next) {
                  return next
              }
              var parent = element.parentElement;
              while (true) {
                  if (!parent || parent.matches("html")) {
                      return false
                  }
                  var parent_next = parent.nextElementSibling;
                  if (parent_next) {
                      return parent_next
                  }
                  parent = parent.parentElement;
              }
          }

          // Return the previous DOM element before the specified one
          // that matches the specified selector.
          function prev(element, selector) {
              var prev = element.previousElementSibling;
              if (prev) {
                  // Find all descendants of the previous element that
                  // match the selector. If there are any, return the
                  // last one.
                  var matches = prev.querySelectorAll(selector);
                  if (matches && matches.length) {
                      return matches[matches.length - 1];
                  }
                  // Otherwise, just return the previous element itself
                  return prev;
              }
              var parent = element.parentElement;
              if (!parent || parent.matches("html")) {
                  return false
              }
              return parent;
          }

          // Use one or the other of the functions above depending
          // on the direction argument.
          var nextCandidate = direction === 'next' ? next : prev;

          element = element[0]; // Convert jQuery argument to DOM
          var candidate = nextCandidate(element, selector);
          while (candidate) {
              if (candidate.matches(selector)) {
                  // Check whether parent is visible to filter out hidden strings
                  // coming from answer widgets in Translation Editor.
                  if (!config.inTranslationEditor || candidate.offsetParent !== null)  {
                    return $(candidate); // Return result as jQuery element
                  }
              }
              candidate = nextCandidate(candidate, selector);
          }
          return false;
      },

      _load_phrases_delayed: function(text, callback) {
        if(config.preload_texts === true) {
          return; // load phrases only once
        }

        $.extend(jipt._phrases.need_load, jipt.get_phrases_from_text(text));
        jipt._phrases.callbacks.push(callback);

        clearTimeout(jipt._phrases.load_timeout);
        jipt._phrases.load_timeout = setTimeout(function() {
          var ids = jipt._phrases.need_load;
          var callbacks = jipt._phrases.callbacks.slice(0);

          jipt._phrases.need_load = {};
          jipt._phrases.callbacks = [];

          for(var id in ids) {
            if(jipt._phrases.was_loaded[id]) {
              delete ids[id];
            }
          }

          $.extend(jipt._phrases.was_loaded, ids);

          if($.isEmptyObject(ids)) {
            return;
          }

          // XXX(kevinb) prevent jipt from loading the same phrase more than
          // once because it only attaches DOM elements to the elements
          // property of the phrase object the first time.  This is because
          // the next time, the jipt strings have already be replaced with
          // their real values so it does't find any DOM nodes with jipt
          // strings and decides not to set element property on the new data.
          // The new data was clobbering the old day without the DOM node
          // which was prevented changes to the translation text from showing
          // up in the preview.
          Object.keys(ids).forEach(function(id) {
            if (jipt.phrases[id]) {
                delete ids[id];
            }
          });

          jipt._load_phrases(ids, callbacks);
        }, 200);
      },

      _load_phrases: function(ids, callbacks) {
        var responses_count = 0;

        // XXX(jlfwong): We always want to get context back from the
        // JIPT phrases to allow us to call mark_state with the context
        // from each phrase. You'd think we could just set
        // config.edit_strings_context, but config.edit_strings_context
        // is expected to either be null or a function, and if it's
        // a function, it causes AJAX calls to *update* the context on
        // Crowdin's side.
        var edit_strings_context = 1;
        // if (config.edit_strings_context && !config.preload_texts) {
        //     edit_strings_context = 1
        // }

        if(config.preload_texts === true) {
          var serialized_ids_chunks = ['all'];
        } else {
          var serialized_ids = jipt.serialize_ids(ids);
          var serialized_ids_chunks = jipt.string_chunks(serialized_ids, 1400, '.');

          if(!serialized_ids_chunks.length) {
            for(var j = 0; j < callbacks.length; j++) {
              callbacks[j]();
            }
            jipt.rebuild_panel_phrases();
            return;
          }
        }

        const callbacksUniqKey = `${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;

        jipt._phrases.strings_callbacks[callbacksUniqKey] = {
          processed_chunks: 0,
          callbacks: callbacks,
          total_chunks: serialized_ids_chunks.length
        };

        for(var i = 0; i < serialized_ids_chunks.length; i++) {
          var message = {
            msg_type: 'load_phrases',
            identifier: callbacksUniqKey,
            ids: config.preload_texts ? ids : serialized_ids_chunks[i],
            url: Url.getFullUrl('/api/v2/jipt/project/' + get_project_identifier() + '/strings'),
            data: {
              languageCode: jipt.language.code,
              workflowStepId: jipt.workflowStep.id,
              editStringsContext: edit_strings_context,
              phrasesIds: serialized_ids_chunks[i]
            }
          };

          jipt.send_post_message(message);
        }
      },

      handle_load_phrases_data: function(message) {
        $.extend(jipt.phrases, message.response.data);

        var ids = typeof message.ids === 'string'
          ? jipt.unserialize_ids(message.ids)
          : message.ids;
        // XXX(joshuan): If we're in Manticore, mutate phrases to mark phrases
        // that fail lint as untranslated.
        // NOTE: The strange indentation is to avoid modifying the original lines.
        function resolve() {

        for (var id in ids) {
          if(typeof jipt.phrases[id] === 'undefined') {
            jipt.phrases[id] = {
              data: {
                hidden: '0',
                id: id,
                status: 'not_found',
                text: [jipt.not_found_warning],
                translation: ['']
              }
            };
          } else {
            if (config.domain && jipt.phrases[id].data.visibleOnStep == false) {
              jipt.phrases[id].data.status = 'not_visible_on_step';
            }

            if (jipt.phrases[id].data.fileNotAvailableForLanguage) {
              jipt.phrases[id].data.status = 'file_not_available_for_language';
            }
          }
        }

        var callbacksUniqKey = message.identifier;
        var stringsCallbacks = jipt._phrases.strings_callbacks[callbacksUniqKey];

        stringsCallbacks.processed_chunks++;

        if(stringsCallbacks.processed_chunks === stringsCallbacks.total_chunks) {
          for(var j = 0; j < stringsCallbacks.callbacks.length; j++) {
            stringsCallbacks.callbacks[j]();
          }

          delete jipt._phrases.strings_callbacks[callbacksUniqKey];
          jipt.rebuild_panel_phrases();
        }
        }
        if (config.ka_on_phrases_received) {
            config.ka_on_phrases_received(jipt.phrases)
              .then(resolve);
        } else {
            resolve();
        }
      },

      make_screenshot: function(screenshotName, error, success, showProgress = false) {
        jipt.callbacks.make_screenshot_error = error;
        jipt.callbacks.make_screenshot_success = success;

        var translationsPreviewEnabled = false;
        var translationsHighlightEnabled = false;

        if (Storage.get('preview') === 'yes') {
          translationsPreviewEnabled = true;
          Storage.save('preview', 'no');
          jipt.init_preview();
          jipt.set_translations_preview();
        }

        if (Storage.get('highlight') === 'yes') {
          translationsHighlightEnabled = true;
          Storage.save('highlight', 'no');
          jipt.init_highlight();
        }

        showProgress && jipt.translationDialog.content.find('#screenshot-status')
          .removeClass('alert-error')
          .addClass('alert-gray')
          .text('Uploading...')
          .show();

        var devicePixelRatio = window.devicePixelRatio;
        var getScale = function (devicePixelRatio) {
          if (devicePixelRatio === 2) {
            return '@2x';
          }

          if (devicePixelRatio >= 3) {
            return '@3x';
          }

          return '';
        }

        html2canvas(document.body, {
          proxy: Url.getFullUrl('/api/v2/jipt/project/' + jipt.projectId + '/screenshots'),
          allowTaint: true,
          scrollY: 0,
          scrollX: 0,
          height: document.body.scrollHeight,
          windowHeight: document.body.scrollHeight,
          logging: true,
        }).then(function(canvas) {

          // Helper function to check if element is visible in viewport
          function isElementVisibleInViewport(element) {
            var rect = element.getBoundingClientRect();
            var win = element.ownerDocument.defaultView;

            // Check if element has zero dimensions (hidden)
            if (rect.width === 0 || rect.height === 0) {
              return false;
            }

            // Check if element is within viewport bounds
            var viewportWidth = win.innerWidth || win.document.documentElement.clientWidth;
            var viewportHeight = win.innerHeight || win.document.documentElement.clientHeight;

            var isInViewport = (
              rect.top >= 0 &&
              rect.left >= 0 &&
              rect.bottom <= viewportHeight &&
              rect.right <= viewportWidth
            );

            if (!isInViewport) {
              return false;
            }

            // Check if element is actually visible (not hidden by CSS)
            var computedStyle = win.getComputedStyle(element);
            if (computedStyle.visibility === 'hidden' ||
                computedStyle.display === 'none' ||
                computedStyle.opacity === '0') {
              return false;
            }

            // Check if element is behind other elements (like dialogs)
            var centerX = rect.left + rect.width / 2;
            var centerY = rect.top + rect.height / 2;
            var topElement = win.document.elementFromPoint(centerX, centerY);

            // If the element at this point is not our element or a child, it might be covered
            if (topElement && !element.contains(topElement) && topElement !== element) {
              return false;
            }

            return true;
          }

          var accumulatedDataForTags = [];

          for (var key in jipt.phrases) {
            var phrase = jipt.phrases[key].data;

            if (!phrase.elements || phrase.status === 'not_found') { // Phrase is not on page or not found, skip it.
              continue;
            }

            for (elementKey in phrase.elements) {
              var element = phrase.elements[elementKey];

              // Skip elements that are not visible in viewport (if option is enabled)
              if (config.tag_only_visible_phrases && !isElementVisibleInViewport(element.element)) {
                continue;
              }

              var win = element.element.ownerDocument.defaultView;
              var bbox = element.element.getBoundingClientRect();

              var x,y,width,height = 0;

              x = Math.round((Math.round(+bbox.x) + win.pageXOffset) * devicePixelRatio);
              y = Math.round((Math.round(+bbox.y) + win.pageYOffset) * devicePixelRatio);
              width = Math.round(Math.round(+bbox.width) * devicePixelRatio);
              height = Math.round(Math.round(+bbox.height) * devicePixelRatio);

              // TODO: Temporary solution. ApiV2 does not allow to set coordinates greater that screenshot height or width.
              // TODO: investigate sticky elements when scrolled to bottom. Now it is displayed exactly in the scrolled place. Element should be on top
              if(y + height > canvas.height || x + width > canvas.width) {
                continue;
              }

              if (!x || !y || !width || !height || x < 0 || y < 0) {
                continue;
              }

              accumulatedDataForTags.push(
                {
                  position: {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                  },
                  stringId: +element.id
                }
              )
            }
          }

          if (translationsHighlightEnabled) {
            Storage.save('highlight', 'yes');
            jipt.init_highlight();
          }

          if (translationsPreviewEnabled) {
            Storage.save('preview', 'yes');
            jipt.init_preview();
            jipt.set_translations_preview();
          }

          var dataURL = canvas.toDataURL('image/jpeg', 0.5);

          var notAllowedChars =  /\\|\/|:|\*|\?|"|<|>|\|/ig;
          screenshotName = screenshotName.replace(notAllowedChars, '.');

          showProgress && jipt.translationDialog.content.find('#screenshot-status').html('Tagging strings...' );

          var message = {};

          var screenshotValue = jipt.translationDialog.content.find('#jipt-screenshots').val();

          if (+screenshotValue > 0) {
            message = {
              msg_type: 'update_screenshot',
              storage_url: Url.getFullUrl('/api/v2/jipt/storages'),
              project_url: Url.getFullUrl('/api/v2/projects/' + jipt.projectModelId),
              data_url: dataURL,
              screenshot_id: screenshotValue,
              storage_screenshot_name: screenshotName,
              scale: getScale(devicePixelRatio),
              accumulated_data_for_tags: accumulatedDataForTags
            };
          } else {
            message = {
              msg_type: 'make_screenshot',
              storage_url: Url.getFullUrl('/api/v2/jipt/storages'),
              project_url: Url.getFullUrl('/api/v2/projects/' + jipt.projectModelId),
              data_url: dataURL,
              storage_screenshot_name: screenshotName,
              scale: getScale(devicePixelRatio),
              accumulated_data_for_tags: accumulatedDataForTags
            };
          }

          jipt.send_post_message(message);
        }).catch(jipt.callbacks.make_screenshot_error);
      },

      handle_make_screenshot_data: function(message) {
        jipt.translationDialog.content.find('#screenshot-status')
          .removeClass('alert-gray')
          .addClass('alert-success')
          .html("Screenshot was successfully uploaded.<br> Name: <i>\"" + htmlspecialchars(message.screenshot_name) + "\"</i>");

        setTimeout(function() {
          if (jipt.translationDialog.content.find('#screenshot-status').hasClass('alert-gray')) {
            return;
          }

          jipt.translationDialog.content.find('#screenshot-status').fadeOut('slow', function() {
            jipt.translationDialog.content.find('#screenshot-status').attr('class', 'screenshot-status');
          })
        }, 5000);
        $(jipt.translationDialog.content.find('#make_screenshot')).attr('disabled', false);
      },

      update_strings_context: function(string_id, context) {
        if(+string_id === 0 || typeof context === 'undefined') {
          return;
        }

        if(!config.preload_texts) {
          var new_context = config.edit_strings_context(context);

          if(editContextTimeout) {
            window.clearTimeout(editContextTimeout);
          }

          if(new_context.length > 1500) {
            console.warn('Crowdin In-Context: Context cannot be updated because it is too long. String ID: ' + string_id);
            return;
          }

          if(context === new_context) {
            return;
          }

          if($.inArray(string_id, stringsToUpdate.updatedStrings) > 0) {
            return;
          } else {
            stringsToUpdate.updatedStrings.push(string_id);
          }

          var stringsToCheck = stringsToUpdate.newStrings.slice();
          stringsToCheck.push({id: string_id, context: new_context});

          if(JSON.stringify(stringsToCheck).length > 1500) {
            jipt.send_strings();
          }

          stringsToUpdate.newStrings.push({
            id: string_id,
            context: new_context
          });

          editContextTimeout = window.setTimeout(function() {
            jipt.send_strings();
          }, 1000);
        }
      },

      send_strings: function() {
        var message = {
          msg_type: 'send_strings',
          url: Url.getFullUrl('/api/v2/jipt/project/' + get_project_identifier() + '/strings'),
          data: {
            origin: window.location.origin,
            workflowStepId: jipt.workflowStep.id,
            strings: stringsToUpdate.newStrings
          }
        };

        jipt.send_post_message(message);

        stringsToUpdate.newStrings.splice(0, stringsToUpdate.newStrings.length);
      },

      get_phrases_from_text: function(text) {
        var phrase_ids = {};

        while(true) {
          var match = jipt.regexp.globalStartPhrase.exec(text);
          if(match === null) {
            break;
          }

          phrase_ids[parseInt(match[1])] = true;
        }

        return phrase_ids;
      },

      serialize_ids: function(ids) {
        var chunks = [];
        var chunk = [];
        var last = 0;

        for(var id in ids) {
          if(id - last !== 1 && chunk.length !== 0) {
            chunks.push(chunk);
            chunk = [];
          }

          chunk.push(id);
          last = id;
        }

        if(chunk.length !== 0) {
          chunks.push(chunk);
        }

        var result = [];
        for(var i = 0; i < chunks.length; i++) {
          var first = chunks[i][0];
          var last = chunks[i][chunks[i].length - 1];

          if(first === last) {
            result.push(first);
          } else {
            result.push(first + '-' + last);
          }
        }

        return result.join('.');
      },

      unserialize_ids: function(ids) {
        var result = {};
        var chunks = ids.split('.');

        for (var i = 0; i < chunks.length; i++) {
          var chunk = chunks[i].split('-');

          if (chunk.length === 1) {
            result[parseInt(chunk[0])] = true;
          } else {
            var start = parseInt(chunk[0]);
            var end = parseInt(chunk[1]);

            for (var id = start; id <= end; id++) {
              result[id] = true;
            }
          }
        }

        return result;
      },

      string_chunks: function(string, size, delimiter) {
        var result = [];

        while(true) {
          var index = string.indexOf(delimiter, size);
          if(index === -1) {
            if(string.length !== 0) {
              result.push(string);
            }
            break;
          }

          result.push(string.slice(0, index));
          string = string.slice(index + 1);
        }

        return result;
      },

      split: function(text, search) {
        var result = [];
        var searchLength = search.length;

        while(true) {
          var searchPos = text.toLowerCase().indexOf(search);

          if(searchPos === -1) {
            result.push(text);
            break;
          }

          result.push(text.substr(0, searchPos));
          text = text.substr(searchPos + searchLength);
        }

        return result;
      },

      get_workflow_proofread_step_id: function() {
        var workflowStepId = this.user.workflowStepId;

        if(workflowStepId == 1 || $.inArray(workflowStepId, this.workflowStepIds) == -1) {
          return this.workflowStepIds[this.workflowStepIds.length-1];
        }

        return workflowStepId;
      },

      get_phrase_status: function(translation_status) {
        if(typeof translation_status == 'string') {
          return translation_status;
        }

        var s_id = this.get_workflow_proofread_step_id();
        var status = this.status.untranslated;

        // in this case it is important to maintain consistency checks
        translation_status.translated               && (status = this.status.translated);

        if(config.domain) {
          translation_status.approved               && (status = this.status.approved);
          translation_status.partially_approved     && (status = this.status.partially_approved);
        } else {
          translation_status.approved[s_id]           && (status = this.status.approved);
          translation_status.partially_approved[s_id] && (status = this.status.partially_approved);
        }

        translation_status.partially_translated     && (status = this.status.partially_translated)
        return status;
      },

      get_in_context_config_url: function(data) {
        if (jipt.projectURL) {
          return jipt.projectURL + '/tools/in-context';
        }

        if (config.domain) {
          return Url.getEntryPoint() + '/u/projects/' + data.projectId + '/tools/in-context';
        }

        return Url.getEntryPoint() + '/project/' + data.projectId + '/tools/in-context';
      }
    };

  // XXX(aberkan): This is moved to the init function so it only gets called when
  // we want the initialization to happen.
  // applyUserConfig();

  if(!window.location.search.match('\\bdisable_jipt\\b') && config.start_type !== 'manual') {
    // XXX(jlfwong): Commented out to allow more granular control of when this
    // is invoked.
    // jipt.init()
  }

  window.jipt = {
    start: () => {
      if (jipt.isStarting || jipt.loginDialog || jipt.editorDialog || jipt.translationDialog) {
        return;
      }

      jipt.init();
    },
    stop: () => {
      if (jipt.loginDialog || jipt.editorDialog || jipt.translationDialog) {
        jipt.destroy();
      }
    },

    target_language: Storage.get('language_code'),

    set_draft_suggestion: function(translation_id, text) {
      jipt.set_draft_suggestion(translation_id, text);
    },

    save_suggestions: function(suggestions, force_saving, callback) {
      jipt.save_suggestions(suggestions, force_saving, callback);
    },

    capture_screenshot: function(screenshotName, options) {
      if(!jipt.user.isManager) {
        return;
      }

      if(!options || options.override !== false) {
        jipt.get_screenshots(screenshotName);
      }

      const error = options && options.error || function() {};
      const success = options && options.success || function() {};

      jipt.make_screenshot(screenshotName, error, success);
    }
  };
})();

var sanitizer = new function() {
  this.uri_protocol_named_ref_map = {Tab: '\t', NewLine: '\n'};
  this.uri_blacklist_protocols = {'javascript':1, 'data':1, 'vbscript':1, 'mhtml':1};
  this.uri_protocol_colon = /(?::|&#[xX]0*3[aA];?|&#0*58;?|&colon;)/;
  this.uri_protocols_whitespaces = /\\n|(?:^[\x00-\x20]+|[\t\n\r\x00]+)/g;
  this.special_attr_value_unquoted_chars = /(?:^(?:["'`]|\x00+$|$)|[\x09-\x0D >])/g;
  this.sensitive_html_entities = /&(?:#([xX][0-9A-Fa-f]+|\d+);?|(Tab|NewLine|colon|semi|lpar|rpar|apos|sol|comma|excl|ast|midast|ensp|emsp|thinsp);|(nbsp|amp|AMP|lt|LT|gt|GT|quot|QUOT);?)/g,
    this.null_value = /\x00/g;

  this.url = function(string) {
    return this.uri_blacklist_protocols[this._getProtocol(this._convertSpecialChars(string))] ? '#' : string;
  };

  this.attributes = function(string) {
    var reg, match, url, i, matches = [];
    reg = /\s+on\w*\s*=\s*("([^"]*")|'[^']*'|([^'">\s]*))/gi; //onClick ...

    while((match = reg.exec(string)) !== null) {
      string = string.replace(match[0], '');
    }

    reg = /\bhref\s*=[^"']*(?:"([^"]*)"|'([^']*)')/gi; //href='javascript:alert(0)'

    while((match = reg.exec(string)) !== null) {
      matches.push(match[1]);
    }

    for(i in matches) {
      url = this.url(matches[i]);
      string = string.replace(matches[i], url);
    }

    return string;
  };

  this.tags = function (string, tags) {
    var self = this;
    var repeat_action = false;

    tags.map(function(tag) {
      var reg = new RegExp('<' + tag + '\\b[^<]*(?:(?!<\\/' + tag + '>)<[^<]*)*((<\\/' + tag + '>)|>)', 'ig');
      var matchFullTag = string.match(reg);

      if(matchFullTag) {
        repeat_action = true;

        if(matchFullTag.length === 1) {
          var matches = reg.exec(string);
          string = self._replaceTags(string, matches);
        } else {
          string = self._replaceTags(string, matchFullTag);
        }
      }
    });

    if(repeat_action) {
      string = self.tags(string, tags);
    }

    return string;
  };

  this._replaceTags = function(string, matches) {
    for(var i = 0, length = matches.length; i < length; i++) {
      string = string.replace(matches[i], '');
    }

    return string;
  };

  this._getRawProtocol = function(string) {
    string = string.split(this.uri_protocol_colon, 2);
    return (string.length === 2 && string[0]) ? string[0] : null;
  };

  this._getProtocol = function(string) {
    string = this._getRawProtocol(string.replace(this.null_value, ''));
    var self = this;
    return string ? this._htmlDecode(string, this.uri_protocol_named_ref_map, this.sensitive_html_entities, function() {
      return this.replace(self.uri_protocols_whitespaces, '').toLowerCase();
    }) : null;
  };

  this._getCharacter = function(num) {
    return !isFinite(num) ||
    num <= 0 ||
    num > 0x10FFFF ||
    num === 0x0B ||
    (num >= 0x01 && num <= 0x08) ||
    (num >= 0x0E && num <= 0x1F) ||
    (num >= 0x7F && num <= 0x9F) ||
    (num >= 0xFDD0 && num <= 0xFDEF) ||
    (num & 0xFFFF) === 0xFFFF ||
    (num & 0xFFFF) === 0xFFFE ? '' : this._fromCodePoint(num);
  };

  this._fromCodePoint = String.fromCodePoint || function(codePoint) {
    if(arguments.length === 0) {
      return '';
    }

    if(codePoint <= 0xFFFF) {
      return String.fromCharCode(codePoint);
    }

    codePoint -= 0x10000;
    return String.fromCharCode((codePoint >> 10) + 0xD800, (codePoint % 0x400) + 0xDC00);
  };

  this._convertSpecialChars = function (string) {
    return this._stringify(string, String.prototype.replace, this.special_attr_value_unquoted_chars, function (m) {
      return m === '\t'   ? '&#9;'
        :  m === '\n'   ? '&#10;'
          :  m === '\x0B' ? '&#11;'
            :  m === '\f'   ? '&#12;'
              :  m === '\r'   ? '&#13;'
                :  m === ' '    ? '&#32;'
                  :  m === '>'    ? '&gt;'
                    :  m === '"'    ? '&quot;'
                      :  m === "'"    ? '&#39;'
                        :  m === '`'    ? '&#96;'
                          :   '';
    });
  };

  this._stringify = function(string, callback) {
    return typeof string === 'undefined' ? 'undefined'
      : string === null                  ? 'null'
        : callback.apply(string.toString(), [].splice.call(arguments, 2));
  };

  this._htmlDecode = function(string, namedRefMap, reNamedRef, callback) {
    var decodedStr, args = [].splice.call(arguments, 4), self = this;

    return this._stringify(string, function() {
      decodedStr = this.replace(this.null_value, '').replace(reNamedRef, function(m, num, named, named1) {
        if (num) {
          num = Number(num[0] <= '9' ? num : '0' + num);
          return (num >= 0xD800 && num <= 0xDFFF) || num === 0x0D ? '' : self._getCharacter(num);
        }

        return namedRefMap[named || named1] || m;
      });

      return callback ? callback.apply(decodedStr, args) : decodedStr;
    });
  }
}

export default globalThis.jiptExport;
